const horizontalslidersetup = (function () {
  // Singleton storage
  let mainsliderContainer,
    mainsliderContainerMain,
    mainsliderWrapper,
    mainsliderFilterAttributes,
    mainsliderItems,
    mainsliderButtons,
    mainsliderCurrentSelectedSlide,
    imagecarouseldiv,
    observer,
    windowsStyles = '',
    textContent = '',
    textContent_en_US = '',
    textContent_de_DE = '',
    textContent_en_GB = '',
    textContent_fr_FR = '',
    textContent_es_419 = '',
    textContent_ja_JP = '',
    textContent_it_IT = '',
    textContent_pt_BR = '',
    textContent_zh_CN = '',
    textContent_cl_en_US = '',
    textContent_cl_de_DE = '',
    textContent_cl_en_GB = '',
    textContent_cl_fr_FR = '',
    textContent_cl_es_419 = '',
    textContent_cl_ja_JP = '',
    textContent_cl_it_IT = '',
    textContent_cl_pt_BR = '',
    textContent_cl_zh_CN = '',

    windowsEdgeStyles = '',
    isUnloading = false,
    shadowRoot;

  const precomputedVariations = new Map();

  const isWindows = navigator.userAgent.includes('Windows');
  const delay = (ms) => new Promise(resolve => setCustomTimeout(resolve, ms));
  const isEdge = navigator.userAgent.includes('Edg/');


  const debounce = (func, delay) => {
    let timeoutId;
    return (...args) => {
      if (timeoutId) clearTimeout(timeoutId);
      timeoutId = setCustomTimeout(() => func(...args), delay);
    };
  };


  const hideSpinner = () => {
    const spinnerContainer = document.getElementById('spinner-container-slider');
    if (spinnerContainer) {
      spinnerContainer.style.display = 'none'; // Hide spinner
    }

  };

  const eventListeners = [];


  const variations = [
    "lefttdbodybluetheme",
    "lefttdbodywhitebluethemenophotoheadercenteronecolumnfang6",
    "lefttdbodynophotoheaderbulletscentersquaresidebar",
    "lefttdbodywhitebluethemenophotoheadercenter",
    "lefttdbodywhitebluethemenophotoheadercentersidebar",
    "lefttdbodynophotoheaderbulletscentersquaresidebar2",
    "lefttdbodythemenophotocenterimages",
    "lefttdbodywhitetheme",
    "lefttdbodywhitethemedark2center",
    "lefttdbodywhitethemenophoto",
    "lefttdbodythemenophotoorange",
    "lefttdbodywhitebluethemenophotoheadercenteronecolumnfang1",
    "lefttdbodywhitebluethemenophotoheadercenteronecolumn",
    "lefttdbodywhitebluethemenophotoheadercenteronecolumnfang2",
    "lefttdbodywhitebluethemenophotoheadercenteronecolumnfang3",
    "lefttdbodythemenophototopbox",
    "lefttdbodygreentheme",
    "lefttdbodywhitebluethemenophoto",
    "lefttdbodywhitebluethemenophotoheaderbulletscenter",
    "lefttdbodywhitebluethemenophotoheaderbullets",
    "lefttdbodywhitebluethemenophotoheaderbulletscentersquare",
    "lefttdbodywhitebluethemenophotoheaderbulletssquare",
    "lefttdbodywhitebluethemenophotoheaderbulletscentersquarebackgroundh3",
    "lefttdbodywhitethememulticolor",
    "lefttdbodywhitebluethemenophotoheadercenteronecolumnfang4",
    "lefttdbodywhitebluethemenophotoheadercenteronecolumnfang5",
    "lefttdbodywhitebluethemenophotoheadercenteronecolumnfang7",
    "lefttdbodywhitebluethemenophotoheadercenteronecolumnfang8",
  ];

  const variationsCL = [
   "lefttdbodybluetheme",
    "lefttdbodywhitebluethemenophotoheadercentersidebar",
    "lefttdbodywhitebluethemenophotoheadercenteronecolumnfang6",
    "lefttdbodywhitebluethemenophotoheadercenteronecolumnfang4",
    "lefttdbodywhitebluethemenophotoheadercenteronecolumnfang8",
  ];

  // Timeless Sleek Bold Refined Future Spark Chic Focus Power Legacy Achiever Clear Additional suggestions: Executive Vibrant Dynamic Elegance Sharp Impactful Trendsetter Empowered Double column Elegant modern Fang Polished Contemporary Creative Stylish Single column Compact Classic High Performer Minimal

  //Consulting
  // Executive Fang Healthcare Marketing performingarts Professional Students Technical, Photo, nophoto
  const variationNamesMap = [
    { id: 'lefttdbodybluetheme', name: 'elegant', style1: 'Photo', style2: 'performingarts', style3: 'Executive', style4: 'Marketing', style5: 'Healthcare', style6: 'Consulting' },
    { id: 'lefttdbodywhitebluethemenophotoheadercenter', name: 'double_column', style1: 'nophoto', style2: 'Technical', style3: 'Professional', style4: 'Executive', style5: 'Consulting', style6: '' },
    { id: 'lefttdbodywhitebluethemenophotoheadercentersidebar', name: 'Timeless', style1: 'nophoto', style2: 'Technical', style3: 'Professional', style4: 'Executive', style5: 'Consulting', style6: '' },
    { id: 'lefttdbodythemenophotocenterimages', name: 'vibrant', style1: 'nophoto', style2: 'performingarts', style3: 'Healthcare', style4: 'Marketing', style5: 'Executive', style6: 'Consulting' },
    { id: 'lefttdbodywhitetheme', name: 'modern', style1: 'Photo', style2: 'Marketing', style3: 'Professional', style4: 'Executive', style5: 'Consulting', style6: 'Students' },
    { id: 'lefttdbodywhitethemedark2', name: 'Innovator', style1: 'Photo', style2: 'Marketing', style3: 'Professional', style4: 'Executive', style5: 'Consulting', style6: 'Students' },
    { id: 'lefttdbodywhitethemedark2center', name: 'Perfectionist', style1: 'nophoto', style2: 'Marketing', style3: 'Professional', style4: 'Executive', style5: 'Consulting', style6: 'Students' },
    { id: 'lefttdbodywhitethemedark2coverletter', name: 'Perfectionist', style1: 'nophoto', style2: 'Marketing', style3: 'Professional', style4: 'Executive', style5: 'Consulting', style6: 'Students' },
    { id: 'lefttdbodywhitethemenophoto', name: 'Magnetic', style1: 'nophoto', style2: 'Marketing', style3: 'Professional', style4: 'Executive', style5: 'Consulting', style6: 'Students' },
    { id: 'lefttdbodythemenophotoorange', name: 'stylish', style1: 'nophoto', style2: 'Students', style3: 'performingarts', style4: 'Marketing', style5: '', style6: '' },
    { id: 'lefttdbodywhitebluethemenophotoheadercenteronecolumn', name: 'single_column', style1: 'nophoto', style2: 'Professional', style3: 'Students', style4: 'Executive', style5: 'Technical', style6: 'Healthcare' },
    { id: 'lefttdbodythemenophototopbox', name: 'trendsetter', style1: 'nophoto', style2: 'Healthcare', style3: 'Marketing', style4: 'Professional', style5: 'Consulting', style6: 'Executive' },
    { id: 'lefttdbodygreentheme', name: 'executive', style1: 'Photo', style2: 'Marketing', style3: 'Executive', style4: 'Students', style5: 'Marketing', style6: 'Healthcare' },
    { id: 'lefttdbodywhitebluethemenophoto', name: 'empowered', style1: 'nophoto', style2: 'Professional', style3: 'Students', style4: 'Executive', style5: 'Technical', style6: 'Consulting' },
    { id: 'lefttdbodywhitebluethemenophotoheaderbulletscenter', name: 'creative', style1: 'nophoto', style2: 'Professional', style3: 'Students', style4: 'Executive', style5: 'Executive', style6: 'Healthcare' },
    { id: 'lefttdbodywhitebluethemenophotoheaderbullets', name: 'future', style1: 'nophoto', style2: 'Professional', style3: 'Students', style4: 'Executive', style5: 'Marketing', style6: 'Healthcare' },
    { id: 'lefttdbodywhitebluethemenophotoheaderbulletscentersquare', name: 'Contemporary', style1: 'nophoto', style2: 'Professional', style3: 'Students', style4: 'Executive', style5: 'Executive', style6: 'Healthcare' },
    { id: 'lefttdbodywhitebluethemenophotoheaderbulletscentersquareCoverLetter', name: 'Contemporary', style1: 'nophoto', style2: 'Professional', style3: 'Students', style4: 'Executive', style5: 'Executive', style6: 'Healthcare' },
    { id: 'lefttdbodywhitebluethemenophotoheaderbulletssquare', name: 'Impactful', style1: 'nophoto', style2: 'Professional', style3: 'Students', style4: 'Executive', style5: 'Executive', style6: 'Healthcare' },
    { id: 'lefttdbodywhitebluethemenophotoheaderbulletscentersquarebackgroundh3', name: 'Spark', style1: 'nophoto', style2: 'Professional', style3: 'Students', style4: 'Executive', style5: 'Executive', style6: 'Healthcare' },
    { id: 'lefttdbodynophotoheaderbulletscentersquaresidebar', name: 'Focus', style1: 'nophoto', style2: 'Professional', style3: 'Students', style4: 'Executive', style5: 'Executive', style6: 'Healthcare' },
    { id: 'lefttdbodynophotoheaderbulletscentersquaresidebar2', name: 'Achiever', style1: 'nophoto', style2: 'Professional', style3: 'Students', style4: 'Executive', style5: 'Executive', style6: 'Healthcare' },
    { id: 'lefttdbodywhitethememulticolor', name: 'Bold', style1: 'Photo', style2: 'Marketing', style3: 'Professional', style4: 'Executive', style5: 'Consulting', style6: 'Students' },
    { id: 'lefttdbodywhitebluethemenophotoheadercenteronecolumnfang8', name: 'Fang 8', style1: 'nophoto', style2: 'Professional', style3: 'Students', style4: 'Fang', style5: 'Technical', style6: 'Healthcare' },
    { id: 'lefttdbodywhitebluethemenophotoheadercenteronecolumnfang2', name: 'Fang 2', style1: 'nophoto', style2: 'Professional', style3: 'Students', style4: 'Fang', style5: 'Technical', style6: 'Healthcare' },
    { id: 'lefttdbodywhitebluethemenophotoheadercenteronecolumnfang3', name: 'Fang 3', style1: 'nophoto', style2: 'Professional', style3: 'Students', style4: 'Fang', style5: 'Technical', style6: 'Healthcare' },
    { id: 'lefttdbodywhitebluethemenophotoheadercenteronecolumnfang4', name: 'Fang 4', style1: 'nophoto', style2: 'Professional', style3: 'Students', style4: 'Fang', style5: 'Technical', style6: 'Healthcare' },
    { id: 'lefttdbodywhitebluethemenophotoheadercenteronecolumnfang5', name: 'Fang 5', style1: 'nophoto', style2: 'Professional', style3: 'Students', style4: 'Fang', style5: 'Technical', style6: 'Healthcare' },
    { id: 'lefttdbodywhitebluethemenophotoheadercenteronecolumnfang6', name: 'Fang 6', style1: 'nophoto', style2: 'Professional', style3: 'Students', style4: 'Fang', style5: 'Technical', style6: 'Healthcare' },
    { id: 'lefttdbodywhitebluethemenophotoheadercenteronecolumnfang7', name: 'Fang 7', style1: 'nophoto', style2: 'Professional', style3: 'Students', style4: 'Fang', style5: 'Technical', style6: 'Healthcare' },
    { id: 'lefttdbodywhitebluethemenophotoheadercenteronecolumnfang1', name: 'Fang 1', style1: 'nophoto', style2: 'Professional', style3: 'Students', style4: 'Fang', style5: 'Technical', style6: 'Healthcare' },


  ];


  // Dynamically translate when accessing
  const getTranslatedVariationNames = () =>
    variationNamesMap.map(item => ({
      ...item,
      name: getI18n(item.name),
    }));

  // Distinct value: beige black blue gold green lavender light blue orange pink purple white ​

  const colorsMap = {
    lefttdbodybluetheme: [
      { id: "default", color: "#375a80", colorname: "blue" },
      { id: "newblue", color: "#b2d4ef", colorname: "lightblue" },
      { id: "salmon", color: "#e9b0ac", colorname: "pink" },
      { id: "green", color: "#5D8064", colorname: "green" },
      { id: "golden", color: "#f1ede4", colorname: "beige" },
    ],
    lefttdbodywhitebluethemenophotoheadercenter: [
      { id: "default", color: "white", colorname: "white" },
      { id: "goldenhighlights", color: "#A67C00", colorname: "gold" },
      { id: "linkbluehighlights", color: "#0070E0", colorname: "blue" },
      { id: "greenhighlights", color: "#5D8064", colorname: "green" },
      { id: "purplehighlights", color: "#53598c", colorname: "purple" },
    ],
    lefttdbodywhitebluethemenophotoheadercentersidebar: [
      { id: "default", color: "#0070E0", colorname: "blue" },
      { id: "goldenhighlights", color: "#A67C00", colorname: "gold" },
      { id: "linkwhitehighlights", color: "white", colorname: "white" },
      { id: "greenhighlights", color: "#5D8064", colorname: "green" },
      { id: "purplehighlights", color: "#53598c", colorname: "purple" },
    ],
    lefttdbodythemenophotocenterimages: [
      { id: "default", color: "#A67C00", colorname: "gold" },
      { id: "whitecenterimages", color: "#FFFFFF", colorname: "white" },
      { id: "bluecenterimages", color: "#375a80", colorname: "blue" },
      { id: "greencenterimages", color: "#5D8064", colorname: "green" },
      { id: "blackcenterimages", color: "#000000", colorname: "black" },
    ],
    lefttdbodywhitethemedark2: [
      { id: "default", color: "#666", colorname: "black" },
      { id: "golden2", color: "#A67C00", colorname: "gold" },
      { id: "blue2", color: "#375a80", colorname: "blue" },
      { id: "green2", color: "#5d8064", colorname: "green" },
      { id: "purple2", color: "#7589ff", colorname: "purple" },
    ],
    lefttdbodywhitethemedark2center: [
      { id: "default", color: "black", colorname: "black" },
      { id: "darkgrey2", color: "#666", colorname: "black" },
      { id: "golden2", color: "#A67C00", colorname: "gold" },
      { id: "blue2", color: "#375a80", colorname: "blue" },
      { id: "purple2", color: "#7589ff", colorname: "purple" },
    ],
    lefttdbodywhitethemedark2coverletter: [
      { id: "default", color: "black", colorname: "black" },
      { id: "darkgrey2", color: "#666", colorname: "black" },
      { id: "golden2", color: "#A67C00", colorname: "gold" },
      { id: "blue2", color: "#375a80", colorname: "blue" },
      { id: "purple2", color: "#7589ff", colorname: "purple" },
    ],
    lefttdbodywhitetheme: [
      { id: "default", color: "#b2d4ef", colorname: "blue" },
      { id: "newblackblack", color: "#FFF", colorname: "white" },
      { id: "newsalmonblack", color: "#e9b0ac", colorname: "pink" },
      { id: "grayorange", color: "#f1ede4", colorname: "beige" },
      { id: "lavendar", color: "#e0e5ff", colorname: "lavender" },
    ],
    lefttdbodywhitethemenophoto: [
      { id: "default", color: "#e9b0ac", colorname: "pink" },
      { id: "newblueblue", color: "#b2d4ef", colorname: "blue" },
      { id: "newblackblack", color: "white", colorname: "white" },
      { id: "grayorange", color: "#f1ede4", colorname: "beige" },
      { id: "lavendar", color: "#e0e5ff", colorname: "lavender" },
    ],
    lefttdbodythemenophotoorange: [
      { id: "default", color: "#474e62", colorname: "blue" },
      { id: "orangewithborder", color: "#f5987a", colorname: "orange" },
      { id: "orangewithwhite", color: "white", colorname: "white" },
      { id: "orangebeige", color: "#f1ede4", colorname: "beige" },
      { id: "orangepurple", color: "#7589ff", colorname: "purple" },
    ],
    lefttdbodywhitebluethemenophotoheadercenteronecolumnfang1: [
      { id: "default", color: "white", colorname: "white" },
      { id: "goldenhighlights", color: "#A67C00", colorname: "gold" },
      { id: "linkbluehighlights", color: "#0070E0", colorname: "blue" },
      { id: "greenhighlights", color: "#5D8064", colorname: "green" },
      { id: "purplehighlights", color: "#53598c", colorname: "purple" },
    ],
    lefttdbodywhitebluethemenophotoheadercenteronecolumn: [
      { id: "default", color: "white", colorname: "white" },
      { id: "goldenhighlights", color: "#A67C00", colorname: "gold" },
      { id: "linkbluehighlights", color: "#0070E0", colorname: "blue" },
      { id: "greenhighlights", color: "#5D8064", colorname: "green" },
      { id: "purplehighlights", color: "#53598c", colorname: "purple" },
    ],
    lefttdbodythemenophototopbox: [
      { id: "default", color: "#A67C00", colorname: "gold" },
      { id: "linkbluetopbox", color: "#0070E0", colorname: "blue" },
      { id: "bluetopbox", color: "#375a80", colorname: "blue" },
      { id: "greentopbox", color: "#5D8064", colorname: "green" },
      { id: "blackdarktopbox", color: "#000000", colorname: "black" },
    ],
    lefttdbodygreentheme: [
      { id: "default", color: "#d8e8e2", colorname: "green" },
      { id: "newbluefullline", color: "#b2d4ef", colorname: "lightblue" },
      { id: "goldenfullline", color: "#e2c395", colorname: "gold" },
      { id: "appricota", color: "#fac0cf", colorname: "pink" },
      { id: "purplefullline", color: "#9ca7e5", colorname: "purple" },
    ],
    lefttdbodywhitebluethemenophoto: [
      { id: "default", color: "#A67C00", colorname: "gold" },
      { id: "linkbluehighlights", color: "#0070E0", colorname: "blue" },
      { id: "bluehighlights", color: "#375a80", colorname: "blue" },
      { id: "greenhighlights", color: "#5D8064", colorname: "green" },
      { id: "purplehighlights", color: "#53598c", colorname: "purple" },
    ],
    lefttdbodywhitebluethemenophotoheaderbulletscenter: [
      { id: "default", color: "white", colorname: "white" },
      { id: "bulletswithgolden", color: "#A67C00", colorname: "gold" },
      { id: "bulletswithblue", color: "#375a80", colorname: "blue" },
      { id: "bulletswithgreen", color: "#5D8064", colorname: "green" },
      { id: "bulletswithpurple", color: "#53598c", colorname: "purple" },
    ],
    lefttdbodywhitebluethemenophotoheaderbullets: [
      { id: "default", color: "white", colorname: "white" },
      { id: "bulletswithgolden", color: "#A67C00", colorname: "gold" },
      { id: "bulletswithblue", color: "#375a80", colorname: "blue" },
      { id: "bulletswithgreen", color: "#5D8064", colorname: "green" },
      { id: "bulletswithpurple", color: "#53598c", colorname: "purple" },
    ],
    lefttdbodywhitebluethemenophotoheaderbulletscentersquare: [
      { id: "default", color: "white", colorname: "white" },
      { id: "bulletswithgolden", color: "#A67C00", colorname: "gold" },
      { id: "bulletswithblue", color: "#375a80", colorname: "blue" },
      { id: "bulletswithgreen", color: "#5D8064", colorname: "green" },
      { id: "bulletswithpurple", color: "#53598c", colorname: "purple" },
    ],
    lefttdbodywhitebluethemenophotoheaderbulletscentersquareCoverLetter: [
      { id: "default", color: "white", colorname: "white" },
      { id: "bulletswithgolden", color: "#A67C00", colorname: "gold" },
      { id: "bulletswithblue", color: "#375a80", colorname: "blue" },
      { id: "bulletswithgreen", color: "#5D8064", colorname: "green" },
      { id: "bulletswithpurple", color: "#53598c", colorname: "purple" },
    ],
    lefttdbodywhitebluethemenophotoheaderbulletssquare: [
      { id: "default", color: "#A67C00", colorname: "gold" },
      { id: "bulletswithwhiteparallelline", color: "white", colorname: "white" },
      { id: "bulletswithblueparallelline", color: "#375a80", colorname: "blue" },
      { id: "bulletswithgreenparallelline", color: "#5D8064", colorname: "green" },
      { id: "bulletswithpurpleparallelline", color: "#53598c", colorname: "purple" },
    ],
    lefttdbodywhitebluethemenophotoheaderbulletscentersquarebackgroundh3: [
      { id: "default", color: "white", colorname: "white" },
      { id: "bulletswithgoldenh3background", color: "#A67C00", colorname: "gold" },
      { id: "bulletswithblueh3background", color: "#375a80", colorname: "blue" },
      { id: "bulletswithgreenh3background", color: "#5D8064", colorname: "green" },
      { id: "bulletswithpurpleh3background", color: "#53598c", colorname: "purple" },
    ],
    lefttdbodynophotoheaderbulletscentersquaresidebar: [
      { id: "default", color: "white", colorname: "white" },
      { id: "bulletswithgolden", color: "#A67C00", colorname: "gold" },
      { id: "bulletswithblue", color: "#375a80", colorname: "blue" },
      { id: "bulletswithgreen", color: "#5D8064", colorname: "green" },
      { id: "bulletswithpink", color: "#d93f67", colorname: "pink" },
    ],
    lefttdbodynophotoheaderbulletscentersquaresidebar2: [
      { id: "default", color: "#f1ede4", colorname: "beige" },
      { id: "bulletswithgoldensidebar", color: "#A67C00", colorname: "gold" },
      { id: "bulletswithbluesidebar", color: "#375a80", colorname: "blue" },
      { id: "bulletswithgreensidebar", color: "#5D8064", colorname: "green" },
      { id: "bulletswithpurplesidebar", color: "#53598c", colorname: "purple" },
    ],
    lefttdbodywhitethememulticolor: [
      { id: "default", color: "#0070E0", colorname: "blue" },
      { id: "goldenhighlights", color: "#A67C00", colorname: "gold" },
      { id: "pinkhighlights", color: "#d93f67", colorname: "pink" },
      { id: "greenhighlights", color: "#5D8064", colorname: "green" },
      { id: "purplehighlights", color: "#53598c", colorname: "purple" },
    ],
    lefttdbodywhitebluethemenophotoheadercenteronecolumnfang2: [
      { id: "default", color: "white", colorname: "white" },
      { id: "goldenhighlights", color: "#A67C00", colorname: "gold" },
      { id: "linkbluehighlights", color: "#0070E0", colorname: "blue" },
      { id: "greenhighlights", color: "#5D8064", colorname: "green" },
      { id: "purplehighlights", color: "#53598c", colorname: "purple" },
    ],
    lefttdbodywhitebluethemenophotoheadercenteronecolumnfang3: [
      { id: "default", color: "white", colorname: "white" },
      { id: "goldenhighlights", color: "#A67C00", colorname: "gold" },
      { id: "linkbluehighlights", color: "#0070E0", colorname: "blue" },
      { id: "greenhighlights", color: "#5D8064", colorname: "green" },
      { id: "purplehighlights", color: "#53598c", colorname: "purple" },
    ],
    lefttdbodywhitebluethemenophotoheadercenteronecolumnfang4: [
      { id: "default", color: "white", colorname: "white" },
      { id: "goldenhighlights", color: "#A67C00", colorname: "gold" },
      { id: "linkbluehighlights", color: "#0070E0", colorname: "blue" },
      { id: "greenhighlights", color: "#5D8064", colorname: "green" },
      { id: "purplehighlights", color: "#53598c", colorname: "purple" },
    ],
    lefttdbodywhitebluethemenophotoheadercenteronecolumnfang5: [
      { id: "default", color: "white", colorname: "white" },
      { id: "goldenhighlights", color: "#A67C00", colorname: "gold" },
      { id: "linkbluehighlights", color: "#0070E0", colorname: "blue" },
      { id: "greenhighlights", color: "#5D8064", colorname: "green" },
      { id: "purplehighlights", color: "#53598c", colorname: "purple" },
    ],
    lefttdbodywhitebluethemenophotoheadercenteronecolumnfang6: [
      { id: "default", color: "white", colorname: "white" },
      { id: "goldenhighlights", color: "#A67C00", colorname: "gold" },
      { id: "linkbluehighlights", color: "#0070E0", colorname: "blue" },
      { id: "greenhighlights", color: "#5D8064", colorname: "green" },
      { id: "purplehighlights", color: "#53598c", colorname: "purple" },
    ],
    lefttdbodywhitebluethemenophotoheadercenteronecolumnfang7: [
      { id: "default", color: "white", colorname: "white" },
      { id: "goldenhighlights", color: "#A67C00", colorname: "gold" },
      { id: "linkbluehighlights", color: "#0070E0", colorname: "blue" },
      { id: "greenhighlights", color: "#5D8064", colorname: "green" },
      { id: "purplehighlights", color: "#53598c", colorname: "purple" },
    ],
    lefttdbodywhitebluethemenophotoheadercenteronecolumnfang8: [
      { id: "default", color: "white", colorname: "white" },
      { id: "goldenhighlights", color: "#A67C00", colorname: "gold" },
      { id: "linkbluehighlights", color: "#0070E0", colorname: "blue" },
      { id: "greenhighlights", color: "#5D8064", colorname: "green" },
      { id: "purplehighlights", color: "#53598c", colorname: "purple" },
    ],

  };

  const fonts = [
    { data: "body-xs", label: "XS" },
    { data: "body-small", label: "S" },
    { data: "body-medium", label: "M" },
    { data: "body-large", label: "L" },
    { data: "body-xlarge", label: "XL" },
  ];

  const languageMultipliers = {
    'en-US': 1,
    'de-DE': 1,
    'en-GB': 1,
    'fr-FR': 1,
    'es-419': 1,
    'ja-JP': 0.95,
    'it-IT': 1,
    'pt-BR': 0.92,
    'zh-CN': 0.92
  };

  const languageMultipliersCL = {
    'en-US': 0.86,
    'de-DE': 0.86,
    'en-GB': 0.86,
    'fr-FR': 0.86,
    'es-419':0.86,
    'ja-JP': 0.86,
    'it-IT': 0.86,
    'pt-BR': 0.86,
    'zh-CN': 0.86
  };




  const init = async (filterValue = null, sourceUrls, content, isResume) => {
    setStyleText();
    mainsliderContainerMain = document.getElementById("mainslider-container-top");
    if (!mainsliderContainerMain) return;
    shadowRoot = mainsliderContainerMain.attachShadow({ mode: "open" });
    mainsliderContainer = document.createElement("div");
    mainsliderContainer.className = "mainslider-container mobile";
    mainsliderContainer.setAttribute("tabindex", "-1");

    // Append styles for the Shadow DOM
    const style = document.createElement("style");
    const language = getLanguage(); // e.g., 'fr-FR', 'de-DE', etc.

    const multiplier = isResume
          ? (languageMultipliers[language] || 1)
          : (languageMultipliersCL[language] || 1);

    let textContentLocale;
    switch (language) {
      case 'de-DE':
        textContentLocale = isResume ? textContent_de_DE : textContent_cl_de_DE;
        break;
      case 'en-GB':
        textContentLocale = isResume ? textContent_en_GB : textContent_cl_en_GB;
        break;
      case 'fr-FR':
        textContentLocale = isResume ? textContent_fr_FR : textContent_cl_fr_FR;
        break;
      case 'es-419':
        textContentLocale = isResume ? textContent_es_419 : textContent_cl_es_419;
        break;
      case 'ja-JP':
        textContentLocale = isResume ? textContent_ja_JP : textContent_cl_ja_JP;
        break;
      case 'it-IT':
        textContentLocale = isResume ? textContent_it_IT : textContent_cl_it_IT;
        break;
      case 'pt-BR':
        textContentLocale = isResume ? textContent_pt_BR : textContent_cl_pt_BR;
        break;
      case 'zh-CN':
        textContentLocale = isResume ? textContent_zh_CN : textContent_cl_zh_CN;
        break;
      default:
        textContentLocale = isResume ? textContent_en_US : textContent_cl_en_US;
        break;
    }

    style.textContent = isWindows
      ? (isEdge ? windowsEdgeStyles + textContent + textContentLocale : windowsStyles + textContent + textContentLocale)
      : textContent + textContentLocale;


    shadowRoot.appendChild(style);

    // Add stylesheets
    const stylesheets = [
      constants.FONT_AWESOME_CSS,
      constants.FONT_AWESOME_STYLE_CSS,
      constants.FONT_AWESOME_STYLE_FREE_CSS,
      constants.GREEN_LEFT_TEMPLATE_CSS
    ];


    stylesheets.forEach((href) => {
      if (!shadowRoot.querySelector(`link[href="${href}"]`)) {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = href;
        shadowRoot.prepend(link);
      } else {
        console.warn(`Stylesheet already loaded: ${href}`);
      }
    });

    shadowRoot.appendChild(mainsliderContainer);

    mainsliderWrapper = document.querySelector(".mainslider-wrapper");
    mainsliderFilterAttributes = document.getElementById("mainslider-filter-attributes");
    imagecarouseldiv = document.getElementById("image-carousel-div");

    addDragToScroll(mainsliderContainer);

    const isMobile = window.innerWidth < 768;

    const mobileHeight = Math.round(740 * multiplier) + 'px';
    const desktopHeight = Math.round(1000 * multiplier) + 'px';
    mainsliderWrapper.style.setProperty('height', isMobile ? mobileHeight : desktopHeight, 'important');

    const mobileImageHeight = Math.round(760 * multiplier) + 'px';
    const desktopImageHeight = Math.round(1020 * multiplier) + 'px';
    imagecarouseldiv.style.height = isMobile ? mobileImageHeight : desktopImageHeight;



    // Add listeners
    addEventListener(mainsliderFilterAttributes, "change", filterSlides);
    addEventListener(window, "resize", () => {
      adjustWidthBasedOnViewport();

    });

    mainsliderContainer.setAttribute("tabindex", "-1");

    // Load and create dynamic slides
    if (Array.isArray(sourceUrls) && sourceUrls.length > 1) {
      await createDynamicSlidesMultipleSrc(sourceUrls, shadowRoot, isResume);
    } else {
      const sourceUrl = Array.isArray(sourceUrls) ? sourceUrls[0] : sourceUrls;
      await createDynamicSlides(sourceUrl, content, shadowRoot , isResume);
    }

    // Clear the precomputed variations and reset the cache
    precomputedVariations.clear();

    // Cache items after slide creation
    mainsliderItems = Array.from(mainsliderContainer.getElementsByClassName("mainslider-item"));

    // Add button event listeners for scrolling
    mainsliderButtons = document.querySelectorAll(".mainslider-button-container button[data-target]");
    mainsliderButtons.forEach(button => {
      addEventListener(button, "click", () =>
        mainsliderScrollToSlide(button.getAttribute("data-target"))
      );
    });

    // Apply filter logic
    applyFilter(filterValue);

    // Initialize layout
    adjustWidthBasedOnViewport();

    // Make content non-selectable
    makeContentNonSelectable(mainsliderContainer);

    // Add a focusin event listener to detect when focus re-enters the mainsliderContaine

    //Uncommenting this as this is not needed
    // mainsliderItems.forEach((item) => {
    //   applyClassesToVariation(item.getAttribute("data-slidename"), null, null, null, "default", "body-small");
    // });


    // Initial arrow visibility


  };







  const lazyLoadInit = (filterValue, sourceUrls, content, isResume) => {
    init(filterValue, sourceUrls, content, isResume);

    //   const targetElement = document.querySelector("#mainslider-container-top");
    //   if (!targetElement) return; // Avoid errors if the element doesn't exist

    //   const observerCallback = async (entries, observerInstance) => {
    //     entries.forEach(async (entry) => {
    //       if (entry.isIntersecting) {
    //         if (isUnloading) return; // Prevent execution if unloading

    //         observerInstance.unobserve(targetElement); // Stop observing this element
    //         await init(filterValue, sourceUrls, content);

    //         // Properly disconnect only this observer instance
    //         observerInstance.disconnect();
    //       }
    //     });
    //   };

    //   // Always create a new observer when calling lazyLoadInit
    //   observer = new IntersectionObserver(observerCallback, {
    //     root: null,
    //     rootMargin: "100px",
    //     threshold: 0.0,
    //   });

    //   observer.observe(targetElement);
  };




  const addDragToScroll = (sliderContainer) => {
    let isDragging = false;
    let startX;
    let scrollLeft;

    const onMouseDown = (e) => {
      isDragging = true;
      startX = e.pageX - sliderContainer.offsetLeft;
      scrollLeft = sliderContainer.scrollLeft;
      e.preventDefault(); // Prevent text selection
    };

    const onMouseMove = (e) => {
      if (!isDragging) return;
      const x = e.pageX - sliderContainer.offsetLeft;
      const walk = (x - startX) * 2; // Adjust multiplier for scroll speed
      sliderContainer.scrollLeft = scrollLeft - walk;
    };

    const onMouseUpOrLeave = () => {
      isDragging = false;
      sliderContainer.classList.remove('dragging'); // Optional for styling
    };

    // Use your existing `addEventListener` function to add event listeners
    addEventListener(sliderContainer, 'mousedown', onMouseDown);
    addEventListener(sliderContainer, 'mousemove', onMouseMove);
    addEventListener(sliderContainer, 'mouseup', onMouseUpOrLeave);
    addEventListener(sliderContainer, 'mouseleave', onMouseUpOrLeave);
  };



  const applyClassesToVariation = (variation, colorId = null, font = null, oldClassName = null, oldColorName = "default", oldFontName = "body-small") => {
    // Clear classes from all slides and elements
    if (!mainsliderItems) return;


    // Find the slide with the given variation
    const slide = mainsliderItems.find(
      item => item.getAttribute("data-slidename") === variation
    );


    if (slide) {

      // Remove 'th_active_color' from all color elements
      const allColorElements = slide.querySelectorAll(".th_square a");
      allColorElements.forEach(el => el.classList.remove("th_active_color"));

      // Remove 'th_active_color' from all font elements
      const allFontElements = slide.querySelectorAll("a.fonttheme");
      allFontElements.forEach(el => el.classList.remove("th_active_color"));

      // Add the 'splide_is_active' class to the slide
      slide.classList.add("splide_is_active");

      const mainContentBodyDiv = slide.querySelector("#maincontent-body");


      const dataAttribute = mainContentBodyDiv.getAttribute('data');
      const data = dataAttribute.split("|");
      const oldClassName = data[0] || null;
      const oldColorName = data[1] || null;
      const oldFontName = data[2] || null;



      const colorClass = colorId || (oldColorName ? oldColorName : "default");
      const fontClass = font || (oldFontName ? oldFontName : "body-small");

      if (mainContentBodyDiv) {
        // Remove all existing classes from mainContentBodyDiv
        mainContentBodyDiv.className = "";

        // Add the new classes dynamically if oldClassName is not null

        mainContentBodyDiv.classList.add(
          "theme-base",
          "body-builderjs-layout",
          "sliderstyle-only",
          variation,
          colorClass,
          fontClass
        );
        mainContentBodyDiv.setAttribute("data", `${variation}|${colorClass}|${fontClass}`);
      }

      // Find and apply 'th_active_color' to the color element
      const colorElement = slide.querySelector(
        `.th_square[id="${colorClass}"] a[data="${variation}|${colorClass}"]`
      );
      if (colorElement) {
        colorElement.classList.add("th_active_color");
      } else {
        console.warn(`No color element found for colorId: ${colorClass}`);
      }

      // Find and apply 'th_active_color' to the font element
      const fontElement = slide.querySelector(`a.fonttheme[data="${variation}|${fontClass}"]`);
      if (fontElement) {
        fontElement.classList.add("th_active_color");
      } else {
        console.warn(`No font element found for font: ${fontClass}`);
      }
    } else {
      console.warn(`No slide found for variation: ${variation}`);
    }
  };






  const addEventListener = (element, type, listener) => {
    if (element) {
      const options = { passive: type === 'wheel' || type === 'touchstart' || type === 'touchmove' }; // Add passive flag only for scroll-blocking events
      element.addEventListener(type, listener, options);
      eventListeners.push({ element, type, listener });
    }
  };



  const createDynamicSlidesMultipleSrc = async (sourceUrls, shadowRoot, isResume) => {
    try {

      const precomputedVariations = new Map(); // Cache for precomputed variations

       // Fetch and prepare content for each source URL
          const preparedContents = await Promise.all(
            sourceUrls.map(async (url) => {
              const html = await fetchContent(url);
              const originalContent = extractBodyContent(html);
              return prepareMainContentBody(originalContent, shadowRoot);
            })
          );

      hideSpinner();

      const isMobile = window.innerWidth < 768;

      const currentVariations = isResume ? variations : variationsCL;
      // Loop through variations and source URLs
      currentVariations.forEach((variation, index) => {
        if (isMobile && index >= 7) return;
        const variationDetails = variationNamesMap.find(item => item.id === variation);
        const photo = variationDetails && variationDetails.style1.toLowerCase() === "photo";
        const preparedContent = preparedContents[index % preparedContents.length]; // Cycle through prepared contents

        // Create a unique cache key for this variation and photo combination
        const cacheKey = `${variation}|${photo}|${index % preparedContents.length}`;

        // Check cache for precomputed result
        let updatedContent;
        if (precomputedVariations.has(cacheKey)) {
          updatedContent = precomputedVariations.get(cacheKey);
        } else {
          // Update content and cache the result
          updatedContent = updateMainContentBody(preparedContent, variation, photo);
          precomputedVariations.set(cacheKey, updatedContent);
        }

        const variationColors = colorsMap[variation] || []; // Get colors for this variation
        const fontsForVariation = fonts; // Fonts are shared across all slides

        // Create the slide with the updated content, colors, and fonts
        createSlide(updatedContent, variation, variationColors, fontsForVariation, isResume);
      });
    } catch (error) {
      console.error("Error creating slides with multiple source URLs:", error);
    }
  };



  const createDynamicSlides = async (sourceUrl, content, shadowRoot) => {

    try {
      let originalContent = '';
      if (!content) {
        const html = await fetchContent(sourceUrl);
        originalContent = extractBodyContent(html);
      } else {
        originalContent = content.body ? content.body.innerHTML : content;
      }
      hideSpinner();
      content = null;

      // Prepare the main content once
      const preparedContent = prepareMainContentBody(originalContent, shadowRoot);
      originalContent = null;

      variations.forEach((variation) => {
        // Retrieve details for the current variation
        const variationDetails = variationNamesMap.find((item) => item.id === variation);
        const photo = variationDetails && variationDetails.style1.toLowerCase() === "photo";
        const updatedContent = updateMainContentBody(preparedContent, variation, photo);

        // Get colors specific to this variation
        const variationColors = colorsMap[variation] || [];

        // Create slide with the updated content and other parameters
        createSlide(updatedContent, variation, variationColors, fonts);
      });
    } catch (error) {
      console.error("Error creating slides:", error);
    }
  };

  const fetchContent = async (url) => {
    // Add a delay of 10 seconds
    await new Promise(resolve => setCustomTimeout(resolve, 0));

    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`Failed to fetch content: ${response.status}`);
    }
    return await response.text();
  };


  const prepareMainContentBody = (originalContent, shadowRoot) => {
    const tempDiv = document.createElement("div");

    tempDiv.innerHTML = originalContent;




    // Add <link> for Google Fonts preconnect
    // const preconnectLink = document.createElement('link');
    // preconnectLink.rel = 'preconnect';
    // preconnectLink.href = 'https://fonts.googleapis.com';
    // tempDiv.prepend(preconnectLink);

    // // Add <link> for Google Fonts styles
    // const googleFontsLink = document.createElement('link');
    // googleFontsLink.rel = 'stylesheet';
    // googleFontsLink.href = 'https://fonts.googleapis.com/css2?family=Lato:wght@700&family=Open+Sans:wght@400;700&family=Oswald&family=Raleway&family=Roboto:wght@400;700&family=Rubik&display=swap';
    // tempDiv.prepend(googleFontsLink);



    // Add the required styles before accessing mainContentBodyDiv
    const paddingStyle = document.createElement("style");
    paddingStyle.id = "padding-style";
    paddingStyle.textContent = `
        .main-table-class {
            --leftdivpadding: 0px 25px 0px 25px;
            --righttdpadding: 0px 25px 0px 20px;
            --righttoppadding: calc(10px + var(--rightoffset)) 25px var(--bottomtoppadding) 20px;
            --image-padding-top: 9px;
            --min-div-height:1200px;
        }
    `;

    const profileImageStyle = document.createElement("style");
    profileImageStyle.textContent = `
        .profileimage-class {
            border-radius: 50%;
            caret-color: transparent;
            width: 100%;
             height: 100%;
            object-fit: cover;
        }
    `;

    tempDiv.prepend(profileImageStyle);
    tempDiv.prepend(paddingStyle);

    const mainContentBodyDiv = tempDiv.querySelector("#maincontent-body");
    if (mainContentBodyDiv) {
      // Clear existing classes
      mainContentBodyDiv.className = "";
      mainContentBodyDiv.style.textAlign = "left";

      // Find and update specific <td> elements
      const tdElementsCoverLetter = mainContentBodyDiv.querySelectorAll(
        'td[class="nopaddingtd coverletterpaddingtd"][style="padding: 0px 0px 0px 0px;"]'
      );
      tdElementsCoverLetter.forEach(td => {
        // Replace the style attribute
        td.setAttribute(
          "style",
          "padding: 0px 0px 0px 0px; text-align:left"
        );
      });

      const tdElements = mainContentBodyDiv.querySelectorAll(
        'td[class="nopaddingtd"][style="padding: 0px 0px 0px 0px;"]'
      );
      tdElements.forEach(td => {
        // Replace the style attribute
        td.setAttribute(
          "style",
          "padding: 0px 0px 0px 0px; text-align:left"
        );
      });

      const divElements = mainContentBodyDiv.querySelectorAll(
        'div[style="display: var(--displayrighttdendemptyspace);"][class="emptyspace-bottom"]'
      );

      if (divElements && divElements.length >= 2) {
        // Convert NodeList to an array and remove the first two elements
        Array.from(divElements).slice(0, 2).forEach(div => div.remove());
      }

      const mainTable = mainContentBodyDiv.querySelector(
        'table#main-table.main-table-class'
      );

      // Check if the table exists and has the class 'main-table-dark'
      if (mainTable && mainTable.classList.contains('main-table-dark')) {
        mainTable.classList.remove('main-table-dark');
      }

      // Find elements with contenteditable="true" and set it to "false"
      const contentEditableElements = mainContentBodyDiv.querySelectorAll('[contenteditable="true"]');
      contentEditableElements.forEach(el => {
        el.setAttribute("contenteditable", "false");
      });

      // Remove all tabindex attributes
      const tabIndexElements = mainContentBodyDiv.querySelectorAll('[tabindex]');
      tabIndexElements.forEach(el => el.removeAttribute('tabindex'));

      // Find all inputs with class "tick-slider-input" and set tabindex="-1"
      const tickSliderInputs = mainContentBodyDiv.querySelectorAll('input.tick-slider-input');
      tickSliderInputs.forEach(input => {
        input.setAttribute('tabindex', '-1');
      });

      updateForLanguage(mainContentBodyDiv);

      const profileImage = mainContentBodyDiv.querySelector("img.profileimage-class");
      const profileImageDiv = mainContentBodyDiv.querySelector("div.profileimagediv-class.image-cropper");

      if (profileImage && profileImageDiv) {
        // Extract the base64 image from the img src attribute
        const base64Image = profileImage.src;

        const existingStyle = Array.from(shadowRoot.querySelectorAll("style")).find(style =>
          style.textContent.includes(".profile-background-image")
        );

        if (!existingStyle) {
          // Create a new style element for the Shadow DOM
          const style = document.createElement("style");

          // Define the .profile-background-image class dynamically
          style.textContent = `
              .profile-background-image {
                  background-image: url('${base64Image}');
                  background-size: cover;
                  background-position: center;
                  background-repeat: no-repeat;
                  caret-color: transparent;
                  width: 140px;
                  height: 140px;
                  position: relative;
                  overflow: hidden;
                  border-radius: 50%;
                  cursor: pointer;
              }
          `;

          // Append the style element to the Shadow DOM
          shadowRoot.appendChild(style);
        }

        // Remove the original <img> tag
        profileImage.remove();

        // Update the existing div to apply the updated styles
        profileImageDiv.classList.add("profile-background-image");
      }
    }

    return tempDiv;
  };


  const updateMainContentBody = (preparedContent, variation, photo) => {
    // Create a unique key for the variation and photo combination
    const cacheKey = `${variation}|${photo}`;

    // Check if the result is already cached
    if (precomputedVariations.has(cacheKey)) {
      return precomputedVariations.get(cacheKey);
    }

    // Compute the variation content if not cached
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = preparedContent.innerHTML; // Use innerHTML to avoid deep cloning

    const mainContentBodyDiv = tempDiv.querySelector("#maincontent-body");
    if (mainContentBodyDiv) {
      // Add required classes dynamically
      mainContentBodyDiv.classList.add(
        "theme-base",
        "body-builderjs-layout",
        "sliderstyle-only",
        variation,
        "default",
        "body-small"
      );

      if (!photo) {
        const profileImageDiv = mainContentBodyDiv.querySelector("div.profileimagediv-class.image-cropper");
        if (profileImageDiv) {
          profileImageDiv.classList.remove("profile-background-image");
        }
      }

      mainContentBodyDiv.setAttribute("data", `${variation}|default|body-small`);
    }

    // Get the updated content as HTML
    const updatedHTML = tempDiv.innerHTML;

    // Cache the computed result
    precomputedVariations.set(cacheKey, updatedHTML);

    return updatedHTML;
  };




  const updateForLanguage = container => {
    const elements = {
      skills: container.querySelector('#skills'),
      strengths: container.querySelector('#strengths'),
      my_career: container.querySelector('#my_career'),
      summary: container.querySelector('#summary'),
      experience: container.querySelector('#experience'),
      education: container.querySelector('#education'),
      technical_skills: container.querySelector('#technical_skills'),
      languages: container.querySelector('#languages'),
      projects: container.querySelector('#projects'),
      portfolio: container.querySelector('#portfolio'),
      certifications: container.querySelector('#certifications'),
      references: container.querySelector('#references'),
      professional_affiliations: container.querySelector('#professional_affiliations'),
      leadership_awards: container.querySelector('#leadership_awards')
    };

    const updateIfEmptyElements = {
      resume_name: container.querySelector('#resume_name'),
      resume_title: container.querySelector('#resume_title'),
      resume_phone: container.querySelector('#resume_phone'),
      resume_email: container.querySelector('#resume_email'),
      resume_linkedin: container.querySelector('#resume_linkedin'),
      resume_addr: container.querySelector('#resume_addr')
    };

    // Update logic for existing fields (always update)
    Object.entries(elements).forEach(([key, element]) => {
      if (element) {
        element.textContent = getI18n(key);
      }
    });

    // Update logic for new fields (only update if the element is empty and exists)
    Object.entries(updateIfEmptyElements).forEach(([key, element]) => {
      if (element && element.textContent.trim() === "") {
        element.textContent = getI18n(key);
      }
    });
  };


  const updateAllSlidesFontAndWidth = (fontName, width) => {
    const slidetopDivs = mainsliderContainer.querySelectorAll(".slide-topdiv");
    const mainsliderItems = mainsliderContainer.querySelectorAll(".mainslider-item");

    // Update width for all slidetopDivs
    slidetopDivs.forEach(div => {
      div.style.width = width;
    });

    // Update font class for all slides
    mainsliderItems.forEach(slide => {
      const mainContentBodyDiv = slide.querySelector("#maincontent-body");
      if (mainContentBodyDiv) {
        // Remove all font-related classes
        mainContentBodyDiv.classList.remove("body-xs", "body-small", "body-medium", "body-large", "body-xlarge");

        // Add the selected font class
        mainContentBodyDiv.classList.add(fontName);

        // Update the data attribute to include the selected font
        const dataAttribute = mainContentBodyDiv.getAttribute("data");
        const dataParts = dataAttribute.split("|");
        dataParts[2] = fontName; // Update the font part of the data attribute
        mainContentBodyDiv.setAttribute("data", dataParts.join("|"));
        applyClassesToVariation(dataParts[0], null, dataParts[2]);
      }
    });
  };





  const extractBodyContent = (html) => {
    try {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      // Extract the body content
      return doc.body ? doc.body.innerHTML : "<div>No content found</div>";
    } catch (error) {
      console.error("Error parsing HTML:", error);
      return "<div>Error parsing content</div>";
    }
  };


  const createSlide = (content, variation, colors, fonts, photo, isResume) => {
    // Create the main slide container
    const slide = document.createElement("div");
    const fragment = document.createDocumentFragment();
    slide.className = "mainslider-item th_container";
    slide.setAttribute("data-name", variation);
    slide.setAttribute("data-slidename", variation);
    slide.setAttribute("tabindex", "0");

    // Create the maintopdiv container
    const maintopDiv = document.createElement("div");
    maintopDiv.className = "maintop-div";

    // Create the font size options container
    const fontContainer = document.createElement("div");
    fontContainer.className = "th_square-container-font th_square-container2row";

    const fontLabel = document.createElement("label");
    fontLabel.className = "font-label"; // Optional: Add a class for styling
    fontLabel.textContent = getI18n('fonts') + ":";

    fontContainer.appendChild(fontLabel);

    fonts.forEach(font => {
      const fontSquare = document.createElement("div");
      fontSquare.className = "th_square";
      fontSquare.style.backgroundColor = "var(--thumbnail-font-color)";

      const fontAnchor = document.createElement("a");
      fontAnchor.className = "fonttheme splide_a color_th font-button";
      fontAnchor.setAttribute("data", `${variation}|${font.data}`);
      fontAnchor.setAttribute("role", "button");
      fontAnchor.innerText = font.label;

      fontSquare.appendChild(fontAnchor);
      fontContainer.appendChild(fontSquare);
      const language = getLanguage(); // e.g., 'fr-FR', 'de-DE', etc.
      const multiplier = isResume
          ? (languageMultipliers[language] || 1)
          : (languageMultipliersCL[language] || 1);


      // Add click event listener for fontAnchor

      addEventListener(fontAnchor, "click", function (event) {
        event.stopPropagation();
        const data = fontAnchor.getAttribute("data").split("|");
        const fontName = data[1];

        const scale = (value) => Math.round(parseInt(value) * multiplier) + "px";

        switch (fontName) {
          case "body-xs":
            mainsliderWrapper.style.height = scale('920');
            imagecarouseldiv.style.height = scale('950');
            updateAllSlidesFontAndWidth(fontName, '540px');
            break;
          case "body-small":
            mainsliderWrapper.style.height = scale('1010');
            imagecarouseldiv.style.height = scale('1030');
            updateAllSlidesFontAndWidth(fontName, '580px');
            break;
          case "body-medium":
            mainsliderWrapper.style.height = scale('1170');
            imagecarouseldiv.style.height = scale('1210');
            updateAllSlidesFontAndWidth(fontName, '610px');
            break;
          case "body-large":
            mainsliderWrapper.style.height = scale('1260');
            imagecarouseldiv.style.height = scale('1310');
            updateAllSlidesFontAndWidth(fontName, '650px');
            break;
          case "body-xlarge":
            mainsliderWrapper.style.height = scale('1360');
            imagecarouseldiv.style.height = scale('1390');
            updateAllSlidesFontAndWidth(fontName, '690px');
            break;
          default:
            mainsliderWrapper.style.height = scale('950');
            imagecarouseldiv.style.height = scale('1000');
            updateAllSlidesFontAndWidth("body-small", '580px');
        }

        applyClassesToVariation(data[0], null, fontName);
      });
    });


    maintopDiv.appendChild(fontContainer); // Add fontContainer to maintopDiv

    // Create the color options container
    const colorContainer = document.createElement("div");
    colorContainer.className = "th_square-container th_square-container2row";

    const colorLabel = document.createElement("label");
    colorLabel.className = "color-label"; // Optional: Add a class for styling
    colorLabel.textContent = getI18n('colors') + ":";

    colorContainer.appendChild(colorLabel);

    colors.forEach(color => {
      const colorSquare = document.createElement("div");
      colorSquare.className = "th_square color-tn"; // Added dummy class
      colorSquare.style.backgroundColor = color.color;
      colorSquare.id = color.id;

      const colorAnchor = document.createElement("a");
      colorAnchor.className = "bodytheme splide_a color_th";
      colorAnchor.setAttribute("data", `${variation}|${color.id}`);
      colorAnchor.setAttribute("data-colorname", color.colorname.toLowerCase()); // Added data-colorname
      colorAnchor.setAttribute("role", "button");

      colorSquare.appendChild(colorAnchor);
      colorContainer.appendChild(colorSquare);

      // Add click event listener for colorSquare
      addEventListener(colorAnchor, "click", function (event) {
        event.stopPropagation(); // Prevent triggering slide click event
        //console.log(`color clicked: ${colorAnchor.getAttribute("data")}`);
        const data = colorAnchor.getAttribute("data").split("|");
        const className = data[0];
        const colorName = data[1];
        applyClassesToVariation(className, colorName, null, null, "default", "body-small");
      });
    });

    maintopDiv.appendChild(colorContainer); // Add colorContainer to maintopDiv
    slide.appendChild(maintopDiv); // Add maintopDiv to slide

    // Create the top container div
    const topDiv = document.createElement("div");
    topDiv.className = "slide-topdiv slide-small-div";

    const isMobile = window.innerWidth < 768;
    topDiv.style.width = isMobile ? `calc(${Math.min(window.innerWidth - 20, 400)}px)` : '580px';



    // Create the main thumbnail anchor
    const mainAnchor = document.createElement("a");
    mainAnchor.className = "bodytheme splide_a main_th";
    mainAnchor.setAttribute("data", `${variation}|default`);
    mainAnchor.setAttribute("role", "button");

    const contentDiv = document.createElement("div");
    contentDiv.className = `content content-${variation}`;
    contentDiv.innerHTML = content;

    mainAnchor.appendChild(contentDiv);
    topDiv.appendChild(mainAnchor); // Enclose mainAnchor inside topDiv
    slide.appendChild(topDiv); // Add topDiv to the slide

    const bottomOfSlide = document.createElement("div");
    bottomOfSlide.className = "bottom-of-slide";

    slide.appendChild(bottomOfSlide);

    // Add a middle-aligned text at the end of the slide
    const middleText = document.createElement("div");
    middleText.className = "middle-text";
    const variationInfo = variationNamesMap.find(item => item.id === variation);
    middleText.innerText = variationInfo ? getI18n(variationInfo.name) : 'Unnamed Variation';
    slide.appendChild(middleText);

    // Add click event listener for the main slide
    addEventListener(slide, "click", function (event) {
      // Ensure the event target is not a child of color or font container
      const target = event.target;
      if (
        target.closest(".color_th") ||
        target.closest(".font-button")
      ) {
        return; // Do nothing if the click originated from a child element
      }
    });

    slide.style.willChange = "contents";
    slide.contentEditable = "false";

    fragment.appendChild(slide);

    mainsliderContainer.appendChild(fragment);
  };




  const adjustWidthBasedOnViewport = () => {
    updateLayout("100%", "100%", true);
  };

  const updateLayout = (width, height, isMobile = true) => {
    if (!mainsliderContainer) return;


    mainsliderContainerMain.style.width = width;
    mainsliderContainerMain.style.height = height;
    mainsliderContainerMain.classList.toggle("mobile", isMobile);
    mainsliderContainerMain.style.overflowY = isMobile ? "hidden" : "auto";
    mainsliderContainerMain.style.overflowX = isMobile ? "auto" : "hidden";


    mainsliderContainer.style.width = width;
    mainsliderContainer.style.height = height;
    mainsliderContainer.classList.toggle("mobile", isMobile);
    mainsliderContainer.style.overflowY = isMobile ? "hidden" : "auto";
    mainsliderContainer.style.overflowX = isMobile ? "auto" : "hidden";

  };

  const filterSlides = () => {
    if (!mainsliderFilterAttributes || mainsliderItems.length === 0) return;

    const selectedAttribute = mainsliderFilterAttributes.value || "all";

    mainsliderItems.forEach((item) => {
      const slideVariation = item.dataset.slidename;

      const variationInfo = variationNamesMap.find((v) => v.id === slideVariation);
      const colors = colorsMap[slideVariation] || [];

      const matchesStyle =
        selectedAttribute === "all" ||
        (variationInfo &&
          Object.keys(variationInfo).some(
            (key) =>
              key.startsWith("style") &&
              variationInfo[key]?.toLowerCase() === selectedAttribute
          ));

      const matchesColor =
        selectedAttribute === "all" ||
        colors.some((color) => color.colorname.toLowerCase() === selectedAttribute);

      // Show or hide the slide based on the matching styles or colors
      item.style.display = matchesStyle || matchesColor ? "flex" : "none";

      // Show all `th_square` color options if style is selected
      const colorSquares = item.querySelectorAll(".th_square.color-tn");
      colorSquares.forEach((square) => {
        const colorMatch =
          selectedAttribute === "all" ||
          colors.some(
            (color) =>
              color.colorname.toLowerCase() === selectedAttribute &&
              square.id === color.id
          );

        // Display only matching color thumbnails for the selected color
        square.style.display = matchesColor ? (colorMatch ? "block" : "none") : "block";
      });
    });
  };



  const applyFilter = filterValue => {
    if (!mainsliderFilterAttributes || mainsliderItems.length === 0) {

      return;
    }

    if (filterValue) {
      mainsliderFilterAttributes.value = filterValue;
    } else {
      mainsliderFilterAttributes.selectedIndex = 0;
    }

    filterSlides();
  };

  const mainsliderScrollToSlide = targetName => {
    if (!mainsliderItems || mainsliderItems.length === 0 || !mainsliderContainer) return;

    const targetSlide = mainsliderItems.find(item => item.getAttribute("data-slidename") === targetName);
    if (targetSlide) {
      mainsliderContainer.scrollTo({
        top: targetSlide.offsetTop - mainsliderContainer.offsetTop,
        left: targetSlide.offsetLeft - mainsliderContainer.offsetLeft,
        behavior: "smooth",
      });
      mainsliderCurrentSelectedSlide = targetSlide;


    }
  };


  const makeContentNonSelectable = element => {
    if (element) {
      element.style.userSelect = "none";
      element.style.webkitUserSelect = "none";
      element.style.msUserSelect = "none";
      element.style.MozUserSelect = "none";
    }
  };


  const moveToNextSlide = async () => {
    if (!mainsliderItems || mainsliderItems.length === 0 || !mainsliderCurrentSelectedSlide) return;

    const currentIndex = mainsliderItems.indexOf(mainsliderCurrentSelectedSlide);
    const nextIndex = (currentIndex + 1) % mainsliderItems.length; // Loop back to the first slide
    const nextSlide = mainsliderItems[nextIndex];

    const className = nextSlide.getAttribute("data-slidename");
    const colorName = "default"; // Adjust as needed for specific slide color selection

    // Remove 'splide_is_active' from all slides
    mainsliderItems.forEach(item => {
      item.classList.remove("splide_is_active");
    });

    mainsliderCurrentSelectedSlide = nextSlide;
    nextSlide.classList.add("splide_is_active");

    mainsliderContainer.scrollTo({
      top: nextSlide.offsetTop - mainsliderContainer.offsetTop,
      behavior: "smooth",
    });


    await delay(50); // Small delay for smooth scrolling

  };

  const moveToPreviousSlide = async () => {
    if (!mainsliderItems || mainsliderItems.length === 0 || !mainsliderCurrentSelectedSlide) return;

    const currentIndex = mainsliderItems.indexOf(mainsliderCurrentSelectedSlide);
    const prevIndex = (currentIndex - 1 + mainsliderItems.length) % mainsliderItems.length; // Loop to the last slide
    const prevSlide = mainsliderItems[prevIndex];

    const className = prevSlide.getAttribute("data-slidename");
    const colorName = "default"; // Adjust as needed for specific slide color selection

    // Remove 'splide_is_active' from all slides
    mainsliderItems.forEach(item => {
      item.classList.remove("splide_is_active");
    });

    mainsliderCurrentSelectedSlide = prevSlide;
    prevSlide.classList.add("splide_is_active");

    mainsliderContainer.scrollTo({
      top: prevSlide.offsetTop - mainsliderContainer.offsetTop,
      behavior: "smooth",
    });


    await delay(50); // Small delay for smooth scrolling

  };

  const setStyleText = () => {

    // Define Windows-specific styles showing light colors because windows black is very black
    windowsStyles = `
  :host {
     --color-black: #222;
    --color-white: #dcdcdc;
  }

  /* Edge-specific styles */
@supports (-ms-ime-align: auto) {
  :host {
   --color-black: #7c7c7c;
    --color-white: #dbdbdb;
  }
}

/* Firefox-specific styles */
@-moz-document url-prefix() {
  :host {
   --color-black: #7c7c7c;
    --color-white: #dbdbdb;
  }
}
  `;


    windowsEdgeStyles = `
    :host {
    --color-black: #7c7c7c;
      --color-white: #dbdbdb;
    }
  `;


    textContent = `

/* /** Slider Container */

@font-face {
  font-family: 'Lato';
  font-style: normal;
  font-weight: 400; /* Regular */
  font-display: swap;
  src: url('/dist/assets/resource/fonts/Lato-Regular.woff2') format('woff2'),
       url('/dist/assets/resource/fonts/Lato-Regular.woff') format('woff'),
       url('/dist/assets/resource/fonts/Lato-Regular.ttf') format('truetype');
}

@font-face {
  font-family: 'Lato';
  font-style: normal;
  font-weight: 700;
  font-display: swap;
  src: url('/dist/assets/resource/fonts/Lato-700.woff2') format('woff2'),
       url('/dist/assets/resource/fonts/Lato-700.woff') format('woff');
}

@font-face {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 400;
  font-stretch: normal;
  font-display: swap;
  src: url('/dist/assets/resource/fonts/OpenSans-400.woff2') format('woff2'),
       url('/dist/assets/resource/fonts/OpenSans-400.woff') format('woff');
}

@font-face {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 700;
  font-stretch: normal;
  font-display: swap;
  src: url('/dist/assets/resource/fonts/OpenSans-700.woff2') format('woff2'),
       url('/dist/assets/resource/fonts/OpenSans-700.woff') format('woff');
}

@font-face {
  font-family: 'Oswald';
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url('/dist/assets/resource/fonts/Oswald-400.woff2') format('woff2'),
       url('/dist/assets/resource/fonts/Oswald-400.woff') format('woff');
}

@font-face {
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url('/dist/assets/resource/fonts/Raleway-400.woff2') format('woff2'),
       url('/dist/assets/resource/fonts/Raleway-400.woff') format('woff');
}

@font-face {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url('/dist/assets/resource/fonts/Roboto-400.woff2') format('woff2'),
       url('/dist/assets/resource/fonts/Roboto-400.woff') format('woff');
}

@font-face {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 700;
  font-display: swap;
  src: url('/dist/assets/resource/fonts/Roboto-700.woff2') format('woff2'),
       url('/dist/assets/resource/fonts/Roboto-700.woff') format('woff');
}

@font-face {
  font-family: 'Rubik';
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: url('/dist/assets/resource/fonts/Rubik-400.woff2') format('woff2'),
       url('/dist/assets/resource/fonts/Rubik-400.woff') format('woff');
}



@font-face {
  font-family: 'Alex Brush';
  font-style: normal;
  font-weight: 400;
  src: url('/dist/assets/resource/fonts/alexbrush-regular-webfont.woff2') format('woff2'), /* Preferred modern format */
       url('/dist/assets/resource/fonts/alexbrush-regular-webfont.woff') format('woff');   /* Fallback for older browsers */
}


.splide_is_active {

  border: 1px solid var( --a-color-blue) !important;
  box-shadow: 0px 0px 0rem 1px #ffffff;
}

.mainslider-filter-container {
  margin-bottom: 20px;
  text-align: center;
}

.mainslider-filter-container label {
  margin-right: 10px;
}

.mainslider-filter-container select {
  padding: 3px;
  font-size: 14px;
}

.mainslider-button-container {
  text-align: center;
  margin-bottom: 20px;
}

.mainslider-button-container button {
  padding: 10px 20px;
  margin: 5px;
  font-size: 16px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  background-color: #007bff;
  color: white;
  transition: background-color 0.3s;
}

.mainslider-button-container button:hover {
  background-color: #0056b3;
}

.mainslider-wrapper {
  position: relative;
  max-width: 100%;
  overflow: hidden;
  /* border: 1px solid #ddd; */
  border-radius: 0px;
  background-color: var(--slider-top);
  display: flex;
  flex-direction: column;
  height: calc(100vh - 125px);
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
}



.slide-topdiv{
  width: 192px;
  overflow: hidden;

}

.mainslider-container {
  flex-grow: 1;
  display: grid;
  gap: 25px;
  row-gap: 25px;
  grid-template-columns: repeat(auto-fit, 195px);
  grid-auto-rows: 353px;
  align-items: start;
  justify-items: start;
  background-color: var(--slider-top);
  overflow-y: auto;
  overflow-x: hidden;
  filter: brightness(var(--slider-brightness));
}

.mainslider-container::-webkit-scrollbar {
  display: none;
}

/* For Firefox */
.mainslider-container {
  scrollbar-width: none; /* Disables the scrollbar in Firefox */
}

/* For Internet Explorer/Edge Legacy */
.mainslider-container {
  -ms-overflow-style: none; /* Hides scrollbars in IE/Edge Legacy */
}




.mainslider-item.selected {
  border: 3px solid #007bff;
}

.mainslider-details {
  margin-top: 10px;
  text-align: center;
}


.mainslider-item {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  border: 1px solid var(--resume-border);
}

.mainslider-container .mainslider-item:focus {
  outline: none;
}

.mainslider-container .mainslider-item:focus-visible {
  outline: none;

}


.mainslider-container.mobile .mainslider-item:last-child {
  margin-right: 60px; /* Ensures last slide isn't cut off on mobile */
}


.mainslider-container.mobile {
  display: flex;
  gap: 10px;
  flex-wrap: nowrap;
  padding: 0px 10px; /* Added padding on both sides to account for scrolling space */
  overflow-x: auto;
  overflow-y: hidden;
}


.mainslider-filter-attributes-dropdown{
  padding: 10px;
  border-radius: 4px;
  font-size: 14px;
  margin-bottom: 10px;
  background-color: var(--slider-top);
  border: 1px solid var(--resume-border);
  color: var(--text-primary);
  -webkit-text-fill-color: var(--text-primary) !important;
  caret-color: var(--text-primary) !important;

}


.th_container {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  margin-right: 0px;
  margin-left: 0px;

}


.bottom-of-slide {
  background-color: var(--resume-background-color);
  z-index: 2;

  padding: 0px 11px 15px 11px;
  margin-top: -25px;
}

.th_square-container-font {
  z-index: 6;
  display: flex;
  justify-content: space-between;

  margin-top: 0px;
  height: 40px;
  padding: 10px 7px 10px 7px;
  background-color: #fff;
  border-top: 1px solid var(--resume-border);
  margin: 0px;
}

.th_square-container {
  z-index: 5;
  display: flex;
  justify-content: space-between;

  margin: 0 auto;
  height: 30px;
  /* margin-top: 30px; */
  /* margin-bottom: 10px; */
  background-color: #fff;
  padding: 10px 7px 10px 7px;
}

.middle-text {
  z-index:2;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2px 10px;
  font-size: 14px;
  width: 100%;
  color: var(--text-primary);
  background-color: var(--resume-background-color);
  border-top: 1px solid var(--resume-border);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap; /* Ensures text stays in a single line */
}


.th_square-container2row {
  background-color: var(--resume-background-color);
  width: 172px;
}

.th_square-container2row.coverletter-item{
  background-color: var(--resume-background-color);
  width: 166px;
}



.th_square {
  width: 22px; /* Adjusted width to fit within the thumbnail */
  height: 22px; /* Adjusted height to fit within the thumbnail */
  background-color: red; /* Default background color for squares */
  margin: 0 5px; /* Adjusted margin for spacing between squares */
}

.th_square a {
  display: block;
  width: 100%;
  height: 100%;
  line-height: 18px;
  border: 1px solid var(--resume-border);
  cursor: pointer;
}

.th_square:hover {
  transform: scale(1.4); /* Zoom out effect on hover */
}

.th_active_color {
  outline: 1px solid var(--a-color-blue);
  outline-offset: 2px;
}


.theme-base {
    --thumbnail-font-color: var(--color-secondary-background);
}







.left-collapsable-templates-light {
		width: 100%;
	}

	.mainslider-container .mainslider-item {
		overflow: visible;

	}



	.mainslider-item div.content {
		transform: scale(.476, .456);
		transform-origin: top left;
		width: 210%;
		height: 190%;
		margin-top: 30px;
		background-color: var(--color-secondary-background);
	}

  .mainslider-item div.content {
    padding: 2px 20px 0px 30px;
}


	.left-collapsable-templates-light {
		background-color: var(--color-secondary-background);
		height: 100%;

	}

	.border-1px-solid {
		border: 1px solid var(--secondary-background-border-color);

	}

	.mainslider-wrapper {
		background-color: var(--slider-background-overwite);
		border-radius: 25px;
	}

	.mainslider-container.mobile {
		gap: 30px;
		padding: 2px 22px;
		margin-top: 15px;

	}

	.font-label,
	.color-label {
		flex-grow: 1;
		padding-right: 5px;
    white-space: nowrap;
	}

	.th_square-container2row {
		width: 80%;
		display: flex;

	}

	.th_square a {
		border: 1px solid var(--secondary-background-border-color);
	}

	.middle-text {
		background-color: var(--color-secondary-background);
		border-top: 0px;
		padding: 0px;

	}

	#mainslider-arrow-container {
		display: none !important;
	}

	.maintop-div {
		padding: 0px 0px 15px 0px;
		border: 1px solid var(--secondary-background-border-color);
		display: flex;
		flex-direction: row-reverse;
		padding: 0;
		z-index: 3;
	}

	.bottom-of-slide {
		display: none;
	}

	.th_square-container-font {
		border-top: 0px;
	}

	.middle-text {
		display: none;
	}

	.splide_is_active {
		border: 0px !important;
		box-shadow: none;
	}

	.applytheme {
		display: none;
	}

	div#image-carousel-div {
		border-radius: 25px !important;
		background-color: var(--slider-background-overwite);
		border: 1px solid var(--secondary-background-border-color);
		padding: 0px;
		margin: 0px;
	}

	.mainslider-item {
		border: 0px;
	}

	.mainslider-container {
		background-color: var(--color-secondary-background);
	}

	.th_square-container2row {
		background-color: var(--color-secondary-background);
	}

	.sliderstyle-only {
		margin: 0px;
		margin-top: 20px;
		border: 0px solid var(--secondary-background-border-color);
		box-shadow: 0 14px 1rem var(--card-boxshadow-image-color-first-path);
	}


	.tox-toolbar__primary_left {
		background-color: var(--color-secondary-background);
		display: none;
	}

	.hidden-content {
		visibility: hidden; /* Prevents flickering */
		opacity: 0; /* Makes it invisible but allows smooth transitions */
	}


  .content-div {
		flex: 1;
		overflow: hidden;
		position: relative;
		width: 100%;
		height: 100%;
	}

	.content-div1 {
		background-color: var(--body-background-color);
	}

	.content-div2 {
		background-color: var(--body-background-color);
	}

	.content-div3 {
		background-color: var(--body-background-color);
	}

	.content-div div.content {
		transform-origin: top left;
		transform: scale(.22, .21) translateZ(0);;
		width: 455%;
		height: 532%;
		position: absolute;
		top: 0;
		left: 0;
		background-color: var(--body-background-color);
	}

	.content-div1 div.content {}

	.content-div2 div.content {
		transform: scale(.22, .205);
	}

	.content-div3 div.content {}


	.mainstyle-only {
		margin: 0px;
		border: 0px solid var(--secondary-background-border-color);
		box-shadow: 0 14px 1rem var(--card-boxshadow-image-color-first-path);

	}

	.content-image-style {
		display: flex;
		align-items: center;
		width: 250px;
		height: 350px;
	}



	.mainslider-filter-attributes-dropdown {
		background-color: var(--color-secondary-background);
	}

@media (max-width: 1260px) {
		.left-collapsable-templates-light {
			display: block;
		}

	}



	@media (max-width: 767px) {

    .mainslider-item div.content {
      padding: 0px;
      margin: 0px 5px 0px 5px;
    }

		.left-collapsable-templates-light {
			height: 405px;
			width: calc(-22px + 100vw);
			margin-left: 0px;
			margin-bottom: 5px;
		}

		.font-label {
			display: none;
		}

		.color-label {
			padding-right: 10px;
		}

		.maintop-div {
			flex-direction: column;
			padding: 0 0 15px 0;

		}

		.th_square-container-font {
			display: none;
		}

		.th_square-container2row {
			width: 100%;
		}


    .mainslider-container .mainslider-item {
    align-items: center;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  @media (max-width: 414px) {
  .mainslider-item div.content {
      padding: 0px;
      margin: 0px;
    }
  }

		.mainslider-container.mobile {
			gap: 10px;
			padding: 2px 7px;
			width: calc(-20px + 100vw);
			height: 260px;

		}


		.sliderstyle-only {
			margin: 0px;
			border: 0px solid var(--secondary-background-border-color);
			box-shadow: 0 14px 1rem var(--card-boxshadow-image-color-first-path);

		}


		.mainslider-item div.content {
			transform: scale(.322);
			transform-origin: top left;
			width: 295%;
			height: 532%;
			position: absolute;
			top: 0;
			left: 0;
      margin-top: 70px;
			background-color: var(--resume-background-color);
		}


	}

  .margintablemarginscale {
    margin-left: 0px !important;
}

#main-table h1 {
    padding-bottom: 10px !important;
}

.main-table-class {
 border-spacing:0px;
  }




/* **/

  `;

    textContent_en_US = `

      .content-lefttdbodybluetheme {
        transform: scale(0.322, 0.3179) !important;
      }

       .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang6 {
        transform: scale(0.322, 0.3416) !important;
      }

      .content-lefttdbodynophotoheaderbulletscentersquaresidebar {
        transform: scale(0.322, 0.2818) !important;
      }

      .content-lefttdbodywhitebluethemenophotoheadercenter {
        transform: scale(0.322, 0.3687) !important;
      }

      .content-lefttdbodywhitebluethemenophotoheadercentersidebar {
        transform: scale(0.322, 0.3856) !important;
      }

      .content-lefttdbodynophotoheaderbulletscentersquaresidebar2 {
        transform: scale(0.322, 0.2784) !important;
      }

      .content-lefttdbodythemenophotocenterimages {
        transform: scale(0.322, 0.3071) !important;
      }

      .content-lefttdbodywhitetheme {
        transform: scale(0.322, 0.3206) !important;
      }

      .content-lefttdbodywhitethemedark2center {
        transform: scale(0.322, 0.3078) !important;
      }

      .content-lefttdbodywhitethemenophoto {
        transform: scale(0.322, 0.3206) !important;
      }

      .content-lefttdbodythemenophotoorange {
        transform: scale(0.322, 0.3078) !important;
      }

      .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang1 {
        transform: scale(0.322, 0.3964) !important;
      }

      .content-lefttdbodywhitebluethemenophotoheadercenteronecolumn {
        transform: scale(0.322, 0.345) !important;
      }

      .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang2 {
        transform: scale(0.322, 0.4174) !important;
      }

      .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang3 {
        transform: scale(0.322, 0.3731) !important;
      }

      .content-lefttdbodythemenophototopbox {
        transform: scale(0.322, 0.3193) !important;
      }

      .content-lefttdbodygreentheme {
        transform: scale(0.322, 0.3308) !important;
      }

      .content-lefttdbodywhitebluethemenophoto {
        transform: scale(0.322, 0.3639) !important;
      }

      .content-lefttdbodywhitebluethemenophotoheaderbulletscenter {
        transform: scale(0.322, 0.3531) !important;
      }

      .content-lefttdbodywhitebluethemenophotoheaderbullets {
        transform: scale(0.322, 0.3044) !important;
      }

      .content-lefttdbodywhitebluethemenophotoheaderbulletscentersquare {
        transform: scale(0.322, 0.3179) !important;
      }

      .content-lefttdbodywhitebluethemenophotoheaderbulletssquare {
        transform: scale(0.322, 0.3179) !important;
      }

      .content-lefttdbodywhitebluethemenophotoheaderbulletscentersquarebackgroundh3 {
        transform: scale(0.322, 0.3044) !important;
      }

      .content-lefttdbodywhitethememulticolor {
        transform: scale(0.322, 0.3281) !important;
      }

      .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang4 {
        transform: scale(0.322, 0.4397) !important;
      }

      .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang5 {
        transform: scale(0.322, 0.3721) !important;
      }



      .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang7 {
        transform: scale(0.322, 0.3497) !important;
      }

      .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang8 {
        transform: scale(0.322, 0.3518) !important;
      }

    @media (min-width: 768px) {
      .content-lefttdbodybluetheme {
        transform: scale(0.476, 0.47) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang6 {
        transform: scale(0.476, 0.506) !important;
      }
      .content-lefttdbodynophotoheaderbulletscentersquaresidebar {
        transform: scale(0.476, 0.4165) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheadercenter {
        transform: scale(0.476, 0.545) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheadercentersidebar {
        transform: scale(0.476, 0.57) !important;
      }

      .content-lefttdbodynophotoheaderbulletscentersquaresidebar2 {
        transform: scale(0.476, 0.4115) !important;
      }
      .content-lefttdbodythemenophotocenterimages {
        transform: scale(0.476, 0.454) !important;
      }
      .content-lefttdbodywhitetheme {
        transform: scale(0.476, 0.474) !important;
      }
      .content-lefttdbodywhitethemedark2center {
        transform: scale(0.476, 0.455) !important;
      }
      .content-lefttdbodywhitethemenophoto {
        transform: scale(0.476, 0.474) !important;
      }
      .content-lefttdbodythemenophotoorange {
        transform: scale(0.476, 0.455) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang1 {
        transform: scale(0.476, 0.586) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheadercenteronecolumn {
        transform: scale(0.476, 0.510) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang2 {
        transform: scale(0.476, 0.617) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang3 {
        transform: scale(0.476, 0.5515) !important;
      }
      .content-lefttdbodythemenophototopbox {
        transform: scale(0.476, 0.472) !important;
      }
      .content-lefttdbodygreentheme {
        transform: scale(0.476, 0.489) !important;
      }
      .content-lefttdbodywhitebluethemenophoto {
        transform: scale(0.476, 0.538) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheaderbulletscenter {
        transform: scale(0.476, 0.522) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheaderbullets {
        transform: scale(0.476, 0.45) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheaderbulletscentersquare {
        transform: scale(0.476, 0.47) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheaderbulletssquare {
        transform: scale(0.476, 0.47) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheaderbulletscentersquarebackgroundh3 {
        transform: scale(0.476, 0.45) !important;
      }
      .content-lefttdbodywhitethememulticolor {
        transform: scale(0.476, 0.485) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang4 {
        transform: scale(0.476, 0.65) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang5 {
        transform: scale(0.476, 0.55) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang7 {
        transform: scale(0.476, 0.517) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang8 {
        transform: scale(0.476, 0.52) !important;
      }
    }
  `;

    textContent_en_GB = `

      .content-lefttdbodybluetheme {
        transform: scale(0.322, 0.3179) !important;
      }
        .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang6 {
        transform: scale(0.322, 0.2788) !important;
      }
      .content-lefttdbodynophotoheaderbulletscentersquaresidebar {
        transform: scale(0.322, 0.2818) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheadercenter {
        transform: scale(0.322, 0.274) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheadercentersidebar {
        transform: scale(0.322, 0.2936) !important;
      }
      .content-lefttdbodynophotoheaderbulletscentersquaresidebar2 {
        transform: scale(0.322, 0.3139) !important;
      }
      .content-lefttdbodythemenophotocenterimages {
        transform: scale(0.322, 0.3288) !important;
      }
      .content-lefttdbodywhitetheme {
        transform: scale(0.322, 0.322) !important;
      }
      .content-lefttdbodywhitethemedark2center {
        transform: scale(0.322, 0.3321) !important;
      }
      .content-lefttdbodywhitethemenophoto {
        transform: scale(0.322, 0.2659) !important;
      }
      .content-lefttdbodythemenophotoorange {
        transform: scale(0.322, 0.3186) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang1 {
        transform: scale(0.322, 0.2902) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheadercenteronecolumn {
        transform: scale(0.322, 0.343) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang2 {
        transform: scale(0.322, 0.4241) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang3 {
        transform: scale(0.322, 0.2929) !important;
      }
      .content-lefttdbodythemenophototopbox {
        transform: scale(0.322, 0.3173) !important;
      }
      .content-lefttdbodygreentheme {
        transform: scale(0.322, 0.3342) !important;
      }
      .content-lefttdbodywhitebluethemenophoto {
        transform: scale(0.322, 0.3173) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheaderbulletscenter {
        transform: scale(0.322, 0.2692) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheaderbullets {
        transform: scale(0.322, 0.2719) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheaderbulletscentersquare {
        transform: scale(0.322, 0.3139) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheaderbulletssquare {
        transform: scale(0.322, 0.3234) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheaderbulletscentersquarebackgroundh3 {
        transform: scale(0.322, 0.2963) !important;
      }
      .content-lefttdbodywhitethememulticolor {
        transform: scale(0.322, 0.345) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang4 {
        transform: scale(0.322, 0.4248) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang5 {
        transform: scale(0.322, 0.3044) !important;
      }

      .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang7 {
        transform: scale(0.322, 0.4126) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang8 {
        transform: scale(0.322, 0.3775) !important;
      }


    @media (min-width: 768px) {
      .content-lefttdbodybluetheme {
        transform: scale(0.476, 0.47) !important;
      }
       .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang6 {
        transform: scale(0.476, 0.4137) !important;
      }
      .content-lefttdbodynophotoheaderbulletscentersquaresidebar {
        transform: scale(0.476, 0.4165) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheadercenter {
        transform: scale(0.476, 0.405) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheadercentersidebar {
        transform: scale(0.476, 0.434) !important;
      }

      .content-lefttdbodynophotoheaderbulletscentersquaresidebar2 {
        transform: scale(0.476, 0.464) !important;
      }
      .content-lefttdbodythemenophotocenterimages {
        transform: scale(0.476, 0.486) !important;
      }
      .content-lefttdbodywhitetheme {
        transform: scale(0.476, 0.476) !important;
      }
      .content-lefttdbodywhitethemedark2center {
        transform: scale(0.476, 0.491) !important;
      }
      .content-lefttdbodywhitethemenophoto {
        transform: scale(0.476, 0.393) !important;
      }
      .content-lefttdbodythemenophotoorange {
        transform: scale(0.476, 0.471) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang1 {
        transform: scale(0.476, 0.429) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheadercenteronecolumn {
        transform: scale(0.476, 0.507) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang2 {
        transform: scale(0.476, 0.627) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang3 {
        transform: scale(0.476, 0.433) !important;
      }
      .content-lefttdbodythemenophototopbox {
        transform: scale(0.476, 0.469) !important;
      }
      .content-lefttdbodygreentheme {
        transform: scale(0.476, 0.494) !important;
      }
      .content-lefttdbodywhitebluethemenophoto {
        transform: scale(0.476, 0.469) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheaderbulletscenter {
        transform: scale(0.476, 0.398) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheaderbullets {
        transform: scale(0.476, 0.402) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheaderbulletscentersquare {
        transform: scale(0.476, 0.464) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheaderbulletssquare {
        transform: scale(0.476, 0.478) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheaderbulletscentersquarebackgroundh3 {
        transform: scale(0.476, 0.438) !important;
      }
      .content-lefttdbodywhitethememulticolor {
        transform: scale(0.476, 0.510) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang4 {
        transform: scale(0.476, 0.628) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang5 {
        transform: scale(0.476, 0.45) !important;
      }

      .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang7 {
        transform: scale(0.476, 0.61) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang8 {
        transform: scale(0.476, 0.558) !important;
      }
    }
  `;


    textContent_de_DE = `

     .content-lefttdbodybluetheme {
    transform: scale(0.322, 0.3175) !important;
  }

   .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang6 {
    transform: scale(0.322, 0.3048) !important;
  }
  .content-lefttdbodynophotoheaderbulletscentersquaresidebar {
    transform: scale(0.322, 0.2847) !important;
  }
  .content-lefttdbodywhitebluethemenophotoheadercenter {
    transform: scale(0.322, 0.2996) !important;
  }
  .content-lefttdbodywhitebluethemenophotoheadercentersidebar {
    transform: scale(0.322, 0.3501) !important;
  }
  .content-lefttdbodynophotoheaderbulletscentersquaresidebar2 {
    transform: scale(0.322, 0.2761) !important;
  }
  .content-lefttdbodythemenophotocenterimages {
    transform: scale(0.322, 0.3389) !important;
  }
  .content-lefttdbodywhitetheme {
    transform: scale(0.322, 0.322) !important;
  }
  .content-lefttdbodywhitethemedark2center {
    transform: scale(0.322, 0.3362) !important;
  }
  .content-lefttdbodywhitethemenophoto {
    transform: scale(0.322, 0.3164) !important;
  }
  .content-lefttdbodythemenophotoorange {
    transform: scale(0.322, 0.2895) !important;
  }
  .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang1 {
    transform: scale(0.322, 0.3994) !important;
  }
  .content-lefttdbodywhitebluethemenophotoheadercenteronecolumn {
    transform: scale(0.322, 0.4518) !important;
  }
  .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang2 {
    transform: scale(0.322, 0.3719) !important;
  }
  .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang3 {
    transform: scale(0.322, 0.3056) !important;
  }
  .content-lefttdbodythemenophototopbox {
    transform: scale(0.322, 0.3316) !important;
  }
  .content-lefttdbodygreentheme {
    transform: scale(0.322, 0.3273) !important;
  }
  .content-lefttdbodywhitebluethemenophoto {
    transform: scale(0.322, 0.3677) !important;
  }
  .content-lefttdbodywhitebluethemenophotoheaderbulletscenter {
    transform: scale(0.322, 0.3449) !important;
  }
  .content-lefttdbodywhitebluethemenophotoheaderbullets {
    transform: scale(0.322, 0.2929) !important;
  }
  .content-lefttdbodywhitebluethemenophotoheaderbulletscentersquare {
    transform: scale(0.322, 0.3273) !important;
  }
  .content-lefttdbodywhitebluethemenophotoheaderbulletssquare {
    transform: scale(0.322, 0.3989) !important;
  }
  .content-lefttdbodywhitebluethemenophotoheaderbulletscentersquarebackgroundh3 {
    transform: scale(0.322, 0.3516) !important;
  }
  .content-lefttdbodywhitethememulticolor {
    transform: scale(0.322, 0.3288) !important;
  }
  .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang4 {
    transform: scale(0.322, 0.4018) !important;
  }
  .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang5 {
    transform: scale(0.322, 0.3167) !important;
  }

  .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang7 {
    transform: scale(0.322, 0.348) !important;
  }
  .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang8 {
    transform: scale(0.322, 0.46) !important;
  }

    @media (min-width: 768px) {
      .content-lefttdbodybluetheme {
        transform: scale(0.476, 0.47) !important;
      }
       .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang6 {
        transform: scale(0.476, 0.451) !important;
      }
      .content-lefttdbodynophotoheaderbulletscentersquaresidebar {
        transform: scale(0.476, 0.421) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheadercenter {
        transform: scale(0.476, 0.4435) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheadercentersidebar {
        transform: scale(0.476, 0.5182) !important;
      }

      .content-lefttdbodynophotoheaderbulletscentersquaresidebar2 {
        transform: scale(0.476, 0.408) !important;
      }
      .content-lefttdbodythemenophotocenterimages {
        transform: scale(0.476, 0.501) !important;
      }
      .content-lefttdbodywhitetheme {
        transform: scale(0.476, 0.476) !important;
      }
      .content-lefttdbodywhitethemedark2center {
        transform: scale(0.476, 0.497) !important;
      }
      .content-lefttdbodywhitethemenophoto {
        transform: scale(0.476, 0.468) !important;
      }
      .content-lefttdbodythemenophotoorange {
        transform: scale(0.476, 0.428) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang1 {
        transform: scale(0.476, 0.591) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheadercenteronecolumn {
        transform: scale(0.476, 0.668) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang2 {
        transform: scale(0.476, 0.55) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang3 {
        transform: scale(0.476, 0.452) !important;
      }
      .content-lefttdbodythemenophototopbox {
        transform: scale(0.476, 0.49) !important;
      }
      .content-lefttdbodygreentheme {
        transform: scale(0.476, 0.484) !important;
      }
      .content-lefttdbodywhitebluethemenophoto {
        transform: scale(0.476, 0.544) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheaderbulletscenter {
        transform: scale(0.476, 0.51) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheaderbullets {
        transform: scale(0.476, 0.433) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheaderbulletscentersquare {
        transform: scale(0.476, 0.484) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheaderbulletssquare {
        transform: scale(0.476, 0.59) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheaderbulletscentersquarebackgroundh3 {
        transform: scale(0.476, 0.52) !important;
      }
      .content-lefttdbodywhitethememulticolor {
        transform: scale(0.476, 0.486) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang4 {
        transform: scale(0.476, 0.594) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang5 {
        transform: scale(0.476, 0.469) !important;
      }

      .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang7 {
        transform: scale(0.476, 0.508) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang8 {
        transform: scale(0.476, 0.67) !important;
      }
    }
  `;

    textContent_fr_FR = `

     .content-lefttdbodybluetheme {
    transform: scale(0.322, 0.284) !important;
  }
    .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang6 {
    transform: scale(0.322, 0.348) !important;
  }
  .content-lefttdbodynophotoheaderbulletscentersquaresidebar {
    transform: scale(0.322, 0.363) !important;
  }
  .content-lefttdbodywhitebluethemenophotoheadercenter {
    transform: scale(0.322, 0.3918) !important;
  }
  .content-lefttdbodywhitebluethemenophotoheadercentersidebar {
    transform: scale(0.322, 0.2923) !important;
  }
  .content-lefttdbodynophotoheaderbulletscentersquaresidebar2 {
    transform: scale(0.322, 0.3418) !important;
  }
  .content-lefttdbodythemenophotocenterimages {
    transform: scale(0.322, 0.3758) !important;
  }
  .content-lefttdbodywhitetheme {
    transform: scale(0.322, 0.2885) !important;
  }
  .content-lefttdbodywhitethemedark2center {
    transform: scale(0.322, 0.2962) !important;
  }
  .content-lefttdbodywhitethemenophoto {
    transform: scale(0.322, 0.338) !important;
  }
  .content-lefttdbodythemenophotoorange {
    transform: scale(0.322, 0.3084) !important;
  }
  .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang1 {
    transform: scale(0.322, 0.3288) !important;
  }
  .content-lefttdbodywhitebluethemenophotoheadercenteronecolumn {
    transform: scale(0.322, 0.4192) !important;
  }
  .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang2 {
    transform: scale(0.322, 0.4602) !important;
  }
  .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang3 {
    transform: scale(0.322, 0.3758) !important;
  }
  .content-lefttdbodythemenophototopbox {
    transform: scale(0.322, 0.3412) !important;
  }
  .content-lefttdbodygreentheme {
    transform: scale(0.322, 0.2911) !important;
  }
  .content-lefttdbodywhitebluethemenophoto {
    transform: scale(0.322, 0.4097) !important;
  }
  .content-lefttdbodywhitebluethemenophotoheaderbulletscenter {
    transform: scale(0.322, 0.3694) !important;
  }
  .content-lefttdbodywhitebluethemenophotoheaderbullets {
    transform: scale(0.322, 0.3447) !important;
  }
  .content-lefttdbodywhitebluethemenophotoheaderbulletscentersquare {
    transform: scale(0.322, 0.318) !important;
  }
  .content-lefttdbodywhitebluethemenophotoheaderbulletssquare {
    transform: scale(0.322, 0.3848) !important;
  }
  .content-lefttdbodywhitebluethemenophotoheaderbulletscentersquarebackgroundh3 {
    transform: scale(0.322, 0.2852) !important;
  }
  .content-lefttdbodywhitethememulticolor {
    transform: scale(0.322, 0.2899) !important;
  }
  .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang4 {
    transform: scale(0.322, 0.3737) !important;
  }
  .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang5 {
    transform: scale(0.322, 0.338) !important;
  }

  .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang7 {
    transform: scale(0.322, 0.4362) !important;
  }
  .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang8 {
    transform: scale(0.322, 0.4183) !important;
  }

    @media (min-width: 768px) {
      .content-lefttdbodybluetheme {
        transform: scale(0.476, 0.42) !important;
      }
         .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang6 {
        transform: scale(0.476, 0.515) !important;
      }
      .content-lefttdbodynophotoheaderbulletscentersquaresidebar {
        transform: scale(0.476, 0.537) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheadercenter {
        transform: scale(0.476, 0.579) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheadercentersidebar {
        transform: scale(0.476, 0.432) !important;
      }

      .content-lefttdbodynophotoheaderbulletscentersquaresidebar2 {
        transform: scale(0.476, 0.5055) !important;
      }
      .content-lefttdbodythemenophotocenterimages {
        transform: scale(0.476, 0.556) !important;
      }
      .content-lefttdbodywhitetheme {
        transform: scale(0.476, 0.427) !important;
      }
      .content-lefttdbodywhitethemedark2center {
        transform: scale(0.476, 0.438) !important;
      }
      .content-lefttdbodywhitethemenophoto {
        transform: scale(0.476, 0.50) !important;
      }
      .content-lefttdbodythemenophotoorange {
        transform: scale(0.476, 0.456) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang1 {
        transform: scale(0.476, 0.486) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheadercenteronecolumn {
        transform: scale(0.476, 0.62) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang2 {
        transform: scale(0.476, 0.68) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang3 {
        transform: scale(0.476, 0.556) !important;
      }
      .content-lefttdbodythemenophototopbox {
        transform: scale(0.476, 0.505) !important;
      }
      .content-lefttdbodygreentheme {
        transform: scale(0.476, 0.43) !important;
      }
      .content-lefttdbodywhitebluethemenophoto {
        transform: scale(0.476, 0.606) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheaderbulletscenter {
        transform: scale(0.476, 0.546) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheaderbullets {
        transform: scale(0.476, 0.51) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheaderbulletscentersquare {
        transform: scale(0.476, 0.47) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheaderbulletssquare {
        transform: scale(0.476, 0.569) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheaderbulletscentersquarebackgroundh3 {
        transform: scale(0.476, 0.422) !important;
      }
      .content-lefttdbodywhitethememulticolor {
        transform: scale(0.476, 0.429) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang4 {
        transform: scale(0.476, 0.553) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang5 {
        transform: scale(0.476, 0.5) !important;
      }

      .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang7 {
        transform: scale(0.476, 0.645) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang8 {
        transform: scale(0.476, 0.617) !important;
      }
    }
  `;


    textContent_es_419 = `

    .content-lefttdbodybluetheme { transform: scale(0.322, 0.304) !important; }
    .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang6 { transform: scale(0.322, 0.282) !important; }
    .content-lefttdbodynophotoheaderbulletscentersquaresidebar { transform: scale(0.322, 0.298) !important; }
    .content-lefttdbodywhitebluethemenophotoheadercenter { transform: scale(0.322, 0.392) !important; }
    .content-lefttdbodywhitebluethemenophotoheadercentersidebar { transform: scale(0.322, 0.334) !important; }
    .content-lefttdbodynophotoheaderbulletscentersquaresidebar2 { transform: scale(0.322, 0.362) !important; }
    .content-lefttdbodythemenophotocenterimages { transform: scale(0.322, 0.266) !important; }
    .content-lefttdbodywhitetheme { transform: scale(0.322, 0.308) !important; }
    .content-lefttdbodywhitethemedark2center { transform: scale(0.322, 0.301) !important; }
    .content-lefttdbodywhitethemenophoto { transform: scale(0.322, 0.297) !important; }
    .content-lefttdbodythemenophotoorange { transform: scale(0.322, 0.305) !important; }
    .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang1 { transform: scale(0.322, 0.36) !important; }
    .content-lefttdbodywhitebluethemenophotoheadercenteronecolumn { transform: scale(0.322, 0.365) !important; }
    .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang2 { transform: scale(0.322, 0.306) !important; }
    .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang3 { transform: scale(0.322, 0.371) !important; }
    .content-lefttdbodythemenophototopbox { transform: scale(0.322, 0.292) !important; }
    .content-lefttdbodygreentheme { transform: scale(0.322, 0.315) !important; }
    .content-lefttdbodywhitebluethemenophoto { transform: scale(0.322, 0.346) !important; }
    .content-lefttdbodywhitebluethemenophotoheaderbulletscenter { transform: scale(0.322, 0.386) !important; }
    .content-lefttdbodywhitebluethemenophotoheaderbullets { transform: scale(0.322, 0.356) !important; }
    .content-lefttdbodywhitebluethemenophotoheaderbulletscentersquare { transform: scale(0.322, 0.348) !important; }
    .content-lefttdbodywhitebluethemenophotoheaderbulletssquare { transform: scale(0.322, 0.388) !important; }
    .content-lefttdbodywhitebluethemenophotoheaderbulletscentersquarebackgroundh3 { transform: scale(0.322, 0.313) !important; }
    .content-lefttdbodywhitethememulticolor { transform: scale(0.322, 0.32) !important; }
    .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang4 { transform: scale(0.322, 0.356) !important; }
    .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang5 { transform: scale(0.322, 0.311) !important; }

    .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang7 { transform: scale(0.322, 0.309) !important; }
    .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang8 { transform: scale(0.322, 0.364) !important; }


    @media (min-width: 768px) {
      .content-lefttdbodybluetheme {
        transform: scale(0.476, 0.45) !important;
      }
       .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang6 {
        transform: scale(0.476, 0.422) !important;
      }
      .content-lefttdbodynophotoheaderbulletscentersquaresidebar {
        transform: scale(0.476, 0.441) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheadercenter {
        transform: scale(0.476, 0.579) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheadercentersidebar {
        transform: scale(0.476, 0.4942) !important;
      }

      .content-lefttdbodynophotoheaderbulletscentersquaresidebar2 {
        transform: scale(0.476, 0.5355) !important;
      }
      .content-lefttdbodythemenophotocenterimages {
        transform: scale(0.476, 0.393) !important;
      }
      .content-lefttdbodywhitetheme {
        transform: scale(0.476, 0.456) !important;
      }
      .content-lefttdbodywhitethemedark2center {
        transform: scale(0.476, 0.445) !important;
      }
      .content-lefttdbodywhitethemenophoto {
        transform: scale(0.476, 0.439) !important;
      }
      .content-lefttdbodythemenophotoorange {
        transform: scale(0.476, 0.451) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang1 {
        transform: scale(0.476, 0.532) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheadercenteronecolumn {
        transform: scale(0.476, 0.54) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang2 {
        transform: scale(0.476, 0.453) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang3 {
        transform: scale(0.476, 0.548) !important;
      }
      .content-lefttdbodythemenophototopbox {
        transform: scale(0.476, 0.431) !important;
      }
      .content-lefttdbodygreentheme {
        transform: scale(0.476, 0.4656) !important;
      }
      .content-lefttdbodywhitebluethemenophoto {
        transform: scale(0.476, 0.512) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheaderbulletscenter {
        transform: scale(0.476, 0.57) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheaderbullets {
        transform: scale(0.476, 0.5258) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheaderbulletscentersquare {
        transform: scale(0.476, 0.514) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheaderbulletssquare {
        transform: scale(0.476, 0.574) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheaderbulletscentersquarebackgroundh3 {
        transform: scale(0.476, 0.462) !important;
      }
      .content-lefttdbodywhitethememulticolor {
        transform: scale(0.476, 0.473) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang4 {
        transform: scale(0.476, 0.531) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang5 {
        transform: scale(0.476, 0.466) !important;
      }

      .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang7 {
        transform: scale(0.476, 0.457) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang8 {
        transform: scale(0.476, 0.538) !important;
      }
    }
  `;


    textContent_ja_JP = `

    .content-lefttdbodybluetheme {
      transform: scale(0.322, 0.3044) !important;
    }
    .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang6 {
      transform: scale(0.322, 0.3727) !important;
    }
    .content-lefttdbodynophotoheaderbulletscentersquaresidebar {
      transform: scale(0.322, 0.3518) !important;
    }
    .content-lefttdbodywhitebluethemenophotoheadercenter {
      transform: scale(0.322, 0.2713) !important;
    }
    .content-lefttdbodywhitebluethemenophotoheadercentersidebar {
      transform: scale(0.322, 0.3499) !important;
    }
    .content-lefttdbodynophotoheaderbulletscentersquaresidebar2 {
      transform: scale(0.322, 0.2476) !important;
    }
    .content-lefttdbodythemenophotocenterimages {
      transform: scale(0.322, 0.2571) !important;
    }
    .content-lefttdbodywhitetheme {
      transform: scale(0.322, 0.3105) !important;
    }
    .content-lefttdbodywhitethemedark2center {
      transform: scale(0.322, 0.3983) !important;
    }
    .content-lefttdbodywhitethemenophoto {
      transform: scale(0.322, 0.3328) !important;
    }
    .content-lefttdbodythemenophotoorange {
      transform: scale(0.322, 0.345) !important;
    }
    .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang1 {
      transform: scale(0.322, 0.3315) !important;
    }
    .content-lefttdbodywhitebluethemenophotoheadercenteronecolumn {
      transform: scale(0.322, 0.3727) !important;
    }
    .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang2 {
      transform: scale(0.322, 0.4248) !important;
    }
    .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang3 {
      transform: scale(0.322, 0.3213) !important;
    }
    .content-lefttdbodythemenophototopbox {
      transform: scale(0.322, 0.3044) !important;
    }
    .content-lefttdbodygreentheme {
      transform: scale(0.322, 0.3179) !important;
    }
    .content-lefttdbodywhitebluethemenophoto {
      transform: scale(0.322, 0.3565) !important;
    }
    .content-lefttdbodywhitebluethemenophotoheaderbulletscenter {
      transform: scale(0.322, 0.3173) !important;
    }
    .content-lefttdbodywhitebluethemenophotoheaderbullets {
      transform: scale(0.322, 0.4011) !important;
    }
    .content-lefttdbodywhitebluethemenophotoheaderbulletscentersquare {
      transform: scale(0.322, 0.3579) !important;
    }
    .content-lefttdbodywhitebluethemenophotoheaderbulletssquare {
      transform: scale(0.322, 0.2892) !important;
    }
    .content-lefttdbodywhitebluethemenophotoheaderbulletscentersquarebackgroundh3 {
      transform: scale(0.322, 0.3781) !important;
    }
    .content-lefttdbodywhitethememulticolor {
      transform: scale(0.322, 0.3213) !important;
    }
    .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang4 {
      transform: scale(0.322, 0.3491) !important;
    }
    .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang5 {
      transform: scale(0.322, 0.4248) !important;
    }
    .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang7 {
      transform: scale(0.322, 0.3078) !important;
    }
    .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang8 {
      transform: scale(0.322, 0.3382) !important;
    }

    @media (min-width: 768px) {
      .content-lefttdbodybluetheme {
        transform: scale(0.476, 0.45) !important;
      }
       .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang6 {
        transform: scale(0.476, 0.551) !important;
      }
      .content-lefttdbodynophotoheaderbulletscentersquaresidebar {
        transform: scale(0.476, 0.52) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheadercenter {
        transform: scale(0.476, 0.401) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheadercentersidebar {
        transform: scale(0.476, 0.5172) !important;
      }

      .content-lefttdbodynophotoheaderbulletscentersquaresidebar2 {
        transform: scale(0.476, 0.366) !important;
      }
      .content-lefttdbodythemenophotocenterimages {
        transform: scale(0.476, 0.38) !important;
      }
      .content-lefttdbodywhitetheme {
        transform: scale(0.476, 0.459) !important;
      }
      .content-lefttdbodywhitethemedark2center {
        transform: scale(0.476, 0.5888) !important;
      }
      .content-lefttdbodywhitethemenophoto {
        transform: scale(0.476, 0.492) !important;
      }
      .content-lefttdbodythemenophotoorange {
        transform: scale(0.476, 0.51) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang1 {
        transform: scale(0.476, 0.49) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheadercenteronecolumn {
        transform: scale(0.476, 0.551) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang2 {
        transform: scale(0.476, 0.628) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang3 {
        transform: scale(0.476, 0.475) !important;
      }
      .content-lefttdbodythemenophototopbox {
        transform: scale(0.476, 0.45) !important;
      }
      .content-lefttdbodygreentheme {
        transform: scale(0.476, 0.47) !important;
      }
      .content-lefttdbodywhitebluethemenophoto {
        transform: scale(0.476, 0.527) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheaderbulletscenter {
        transform: scale(0.476, 0.469) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheaderbullets {
        transform: scale(0.476, 0.593) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheaderbulletscentersquare {
        transform: scale(0.476, 0.529) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheaderbulletssquare {
        transform: scale(0.476, 0.4275) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheaderbulletscentersquarebackgroundh3 {
        transform: scale(0.476, 0.559) !important;
      }
      .content-lefttdbodywhitethememulticolor {
        transform: scale(0.476, 0.475) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang4 {
        transform: scale(0.476, 0.516) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang5 {
        transform: scale(0.476, 0.628) !important;
      }

      .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang7 {
        transform: scale(0.476, 0.455) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang8 {
        transform: scale(0.476, 0.50) !important;
      }
    }
  `;


    textContent_it_IT = `

   .content-lefttdbodybluetheme {
    transform: scale(0.322, 0.3044) !important;
  }
  .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang6 {
    transform: scale(0.322, 0.3138) !important;
  }
  .content-lefttdbodynophotoheaderbulletscentersquaresidebar {
    transform: scale(0.322, 0.3825) !important;
  }
  .content-lefttdbodywhitebluethemenophotoheadercenter {
    transform: scale(0.322, 0.2556) !important;
  }
  .content-lefttdbodywhitebluethemenophotoheadercentersidebar {
    transform: scale(0.322, 0.3323) !important;
  }
  .content-lefttdbodynophotoheaderbulletscentersquaresidebar2 {
    transform: scale(0.322, 0.2976) !important;
  }
  .content-lefttdbodythemenophotocenterimages {
    transform: scale(0.322, 0.3528) !important;
  }
  .content-lefttdbodywhitetheme {
    transform: scale(0.322, 0.3087) !important;
  }
  .content-lefttdbodywhitethemedark2center {
    transform: scale(0.322, 0.3864) !important;
  }
  .content-lefttdbodywhitethemenophoto {
    transform: scale(0.322, 0.2651) !important;
  }
  .content-lefttdbodythemenophotoorange {
    transform: scale(0.322, 0.3145) !important;
  }
  .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang1 {
    transform: scale(0.322, 0.3411) !important;
  }
  .content-lefttdbodywhitebluethemenophotoheadercenteronecolumn {
    transform: scale(0.322, 0.2971) !important;
  }
  .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang2 {
    transform: scale(0.322, 0.3835) !important;
  }
  .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang3 {
    transform: scale(0.322, 0.3114) !important;
  }
  .content-lefttdbodythemenophototopbox {
    transform: scale(0.322, 0.3393) !important;
  }
  .content-lefttdbodygreentheme {
    transform: scale(0.322, 0.3099) !important;
  }
  .content-lefttdbodywhitebluethemenophoto {
    transform: scale(0.322, 0.2803) !important;
  }
  .content-lefttdbodywhitebluethemenophotoheaderbulletscenter {
    transform: scale(0.322, 0.3138) !important;
  }
  .content-lefttdbodywhitebluethemenophotoheaderbullets {
    transform: scale(0.322, 0.3428) !important;
  }
  .content-lefttdbodywhitebluethemenophotoheaderbulletscentersquare {
    transform: scale(0.322, 0.3565) !important;
  }
  .content-lefttdbodywhitebluethemenophotoheaderbulletssquare {
    transform: scale(0.322, 0.3575) !important;
  }
  .content-lefttdbodywhitebluethemenophotoheaderbulletscentersquarebackgroundh3 {
    transform: scale(0.322, 0.3666) !important;
  }
  .content-lefttdbodywhitethememulticolor {
    transform: scale(0.322, 0.3121) !important;
  }
  .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang4 {
    transform: scale(0.322, 0.4128) !important;
  }
  .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang5 {
    transform: scale(0.322, 0.3353) !important;
  }
  .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang7 {
    transform: scale(0.322, 0.3866) !important;
  }
  .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang8 {
    transform: scale(0.322, 0.3144) !important;
  }

    @media (min-width: 768px) {
      .content-lefttdbodybluetheme {
        transform: scale(0.476, 0.45) !important;
      }
       .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang6 {
        transform: scale(0.476, 0.464) !important;
      }
      .content-lefttdbodynophotoheaderbulletscentersquaresidebar {
        transform: scale(0.476, 0.565) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheadercenter {
        transform: scale(0.476, 0.378) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheadercentersidebar {
        transform: scale(0.476, 0.491) !important;
      }

      .content-lefttdbodynophotoheaderbulletscentersquaresidebar2 {
        transform: scale(0.476, 0.44) !important;
      }
      .content-lefttdbodythemenophotocenterimages {
        transform: scale(0.476, 0.5215) !important;
      }
      .content-lefttdbodywhitetheme {
        transform: scale(0.476, 0.456) !important;
      }
      .content-lefttdbodywhitethemedark2center {
        transform: scale(0.476, 0.571) !important;
      }
      .content-lefttdbodywhitethemenophoto {
        transform: scale(0.476, 0.392) !important;
      }
      .content-lefttdbodythemenophotoorange {
        transform: scale(0.476, 0.465) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang1 {
        transform: scale(0.476, 0.504) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheadercenteronecolumn {
        transform: scale(0.476, 0.44) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang2 {
        transform: scale(0.476, 0.567) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang3 {
        transform: scale(0.476, 0.46) !important;
      }
      .content-lefttdbodythemenophototopbox {
        transform: scale(0.476, 0.502) !important;
      }
      .content-lefttdbodygreentheme {
        transform: scale(0.476, 0.458) !important;
      }
      .content-lefttdbodywhitebluethemenophoto {
        transform: scale(0.476, 0.415) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheaderbulletscenter {
        transform: scale(0.476, 0.464) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheaderbullets {
        transform: scale(0.476, 0.506) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheaderbulletscentersquare {
        transform: scale(0.476, 0.527) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheaderbulletssquare {
        transform: scale(0.476, 0.529) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheaderbulletscentersquarebackgroundh3 {
        transform: scale(0.476, 0.542) !important;
      }
      .content-lefttdbodywhitethememulticolor {
        transform: scale(0.476, 0.461) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang4 {
        transform: scale(0.476, 0.61) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang5 {
        transform: scale(0.476, 0.496) !important;
      }

      .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang7 {
        transform: scale(0.476, 0.572) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang8 {
        transform: scale(0.476, 0.4645) !important;
      }
    }
  `;



    textContent_pt_BR = `

  .content-lefttdbodybluetheme {
  transform: scale(0.322, 0.3315) !important;
  }
  .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang6 {
    transform: scale(0.322, 0.3332) !important;
  }
  .content-lefttdbodynophotoheaderbulletscentersquaresidebar {
    transform: scale(0.322, 0.2889) !important;
  }
  .content-lefttdbodywhitebluethemenophotoheadercenter {
    transform: scale(0.322, 0.322) !important;
  }
  .content-lefttdbodywhitebluethemenophotoheadercentersidebar {
    transform: scale(0.322, 0.3024) !important;
  }
  .content-lefttdbodynophotoheaderbulletscentersquaresidebar2 {
    transform: scale(0.322, 0.3254) !important;
  }
  .content-lefttdbodythemenophotocenterimages {
    transform: scale(0.322, 0.2983) !important;
  }
  .content-lefttdbodywhitetheme {
    transform: scale(0.322, 0.3342) !important;
  }
  .content-lefttdbodywhitethemedark2center {
    transform: scale(0.322, 0.2631) !important;
  }
  .content-lefttdbodywhitethemenophoto {
    transform: scale(0.322, 0.276) !important;
  }
  .content-lefttdbodythemenophotoorange {
    transform: scale(0.322, 0.251) !important;
  }
  .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang1 {
    transform: scale(0.322, 0.3044) !important;
  }
  .content-lefttdbodywhitebluethemenophotoheadercenteronecolumn {
    transform: scale(0.322, 0.3071) !important;
  }
  .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang2 {
    transform: scale(0.322, 0.3416) !important;
  }
  .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang3 {
    transform: scale(0.322, 0.4032) !important;
  }
  .content-lefttdbodythemenophototopbox {
    transform: scale(0.322, 0.3051) !important;
  }
  .content-lefttdbodygreentheme {
    transform: scale(0.322, 0.3416) !important;
  }
  .content-lefttdbodywhitebluethemenophoto {
    transform: scale(0.322, 0.3254) !important;
  }
  .content-lefttdbodywhitebluethemenophotoheaderbulletscenter {
    transform: scale(0.322, 0.2997) !important;
  }
  .content-lefttdbodywhitebluethemenophotoheaderbullets {
    transform: scale(0.322, 0.3146) !important;
  }
  .content-lefttdbodywhitebluethemenophotoheaderbulletscentersquare {
    transform: scale(0.322, 0.32) !important;
  }
  .content-lefttdbodywhitebluethemenophotoheaderbulletssquare {
    transform: scale(0.322, 0.3511) !important;
  }
  .content-lefttdbodywhitebluethemenophotoheaderbulletscentersquarebackgroundh3 {
    transform: scale(0.322, 0.2993) !important;
  }
  .content-lefttdbodywhitethememulticolor {
    transform: scale(0.322, 0.3436) !important;
  }
  .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang4 {
    transform: scale(0.322, 0.3795) !important;
  }
  .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang5 {
    transform: scale(0.322, 0.3646) !important;
  }
  .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang7 {
    transform: scale(0.322, 0.343) !important;
  }
  .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang8 {
    transform: scale(0.322, 0.368) !important;
  }


    @media (min-width: 768px) {
      .content-lefttdbodybluetheme {
        transform: scale(0.476, 0.49) !important;
      }
       .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang6 {
        transform: scale(0.476, 0.4926) !important;
      }
      .content-lefttdbodynophotoheaderbulletscentersquaresidebar {
        transform: scale(0.476, 0.427) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheadercenter {
        transform: scale(0.476, 0.476) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheadercentersidebar {
        transform: scale(0.476, 0.447) !important;
      }

      .content-lefttdbodynophotoheaderbulletscentersquaresidebar2 {
        transform: scale(0.476, 0.481) !important;
      }
      .content-lefttdbodythemenophotocenterimages {
        transform: scale(0.476, 0.441) !important;
      }
      .content-lefttdbodywhitetheme {
        transform: scale(0.476, 0.494) !important;
      }
      .content-lefttdbodywhitethemedark2center {
        transform: scale(0.476, 0.389) !important;
      }
      .content-lefttdbodywhitethemenophoto {
        transform: scale(0.476, 0.408) !important;
      }
      .content-lefttdbodythemenophotoorange {
        transform: scale(0.476, 0.371) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang1 {
        transform: scale(0.476, 0.45) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheadercenteronecolumn {
        transform: scale(0.476, 0.454) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang2 {
        transform: scale(0.476, 0.505) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang3 {
        transform: scale(0.476, 0.596) !important;
      }
      .content-lefttdbodythemenophototopbox {
        transform: scale(0.476, 0.451) !important;
      }
      .content-lefttdbodygreentheme {
        transform: scale(0.476, 0.505) !important;
      }
      .content-lefttdbodywhitebluethemenophoto {
        transform: scale(0.476, 0.481) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheaderbulletscenter {
        transform: scale(0.476, 0.443) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheaderbullets {
        transform: scale(0.476, 0.465) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheaderbulletscentersquare {
        transform: scale(0.476, 0.473) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheaderbulletssquare {
        transform: scale(0.476, 0.519) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheaderbulletscentersquarebackgroundh3 {
        transform: scale(0.476, 0.4425) !important;
      }
      .content-lefttdbodywhitethememulticolor {
        transform: scale(0.476, 0.508) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang4 {
        transform: scale(0.476, 0.561) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang5 {
        transform: scale(0.476, 0.539) !important;
      }

      .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang7 {
        transform: scale(0.476, 0.507) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang8 {
        transform: scale(0.476, 0.544) !important;
      }
    }
  `;


    textContent_zh_CN = `

  .content-lefttdbodybluetheme {
  transform: scale(0.322, 0.331) !important;
  }
  .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang6 {
    transform: scale(0.322, 0.354) !important;
  }
  .content-lefttdbodynophotoheaderbulletscentersquaresidebar {
    transform: scale(0.322, 0.304) !important;
  }
  .content-lefttdbodywhitebluethemenophotoheadercenter {
    transform: scale(0.322, 0.389) !important;
  }
  .content-lefttdbodywhitebluethemenophotoheadercentersidebar {
    transform: scale(0.322, 0.372) !important;
  }
  .content-lefttdbodynophotoheaderbulletscentersquaresidebar2 {
    transform: scale(0.322, 0.267) !important;
  }
  .content-lefttdbodythemenophotocenterimages {
    transform: scale(0.322, 0.331) !important;
  }
  .content-lefttdbodywhitetheme {
    transform: scale(0.322, 0.333) !important;
  }
  .content-lefttdbodywhitethemedark2center {
    transform: scale(0.322, 0.334) !important;
  }
  .content-lefttdbodywhitethemenophoto {
    transform: scale(0.322, 0.241) !important;
  }
  .content-lefttdbodythemenophotoorange {
    transform: scale(0.322, 0.251) !important;
  }
  .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang1 {
    transform: scale(0.322, 0.314) !important;
  }
  .content-lefttdbodywhitebluethemenophotoheadercenteronecolumn {
    transform: scale(0.322, 0.364) !important;
  }
  .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang2 {
    transform: scale(0.322, 0.356) !important;
  }
  .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang3 {
    transform: scale(0.322, 0.388) !important;
  }
  .content-lefttdbodythemenophototopbox {
    transform: scale(0.322, 0.306) !important;
  }
  .content-lefttdbodygreentheme {
    transform: scale(0.322, 0.336) !important;
  }
  .content-lefttdbodywhitebluethemenophoto {
    transform: scale(0.322, 0.361) !important;
  }
  .content-lefttdbodywhitebluethemenophotoheaderbulletscenter {
    transform: scale(0.322, 0.305) !important;
  }
  .content-lefttdbodywhitebluethemenophotoheaderbullets {
    transform: scale(0.322, 0.269) !important;
  }
  .content-lefttdbodywhitebluethemenophotoheaderbulletscentersquare {
    transform: scale(0.322, 0.306) !important;
  }
  .content-lefttdbodywhitebluethemenophotoheaderbulletssquare {
    transform: scale(0.322, 0.342) !important;
  }
  .content-lefttdbodywhitebluethemenophotoheaderbulletscentersquarebackgroundh3 {
    transform: scale(0.322, 0.340) !important;
  }
  .content-lefttdbodywhitethememulticolor {
    transform: scale(0.322, 0.338) !important;
  }
  .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang4 {
    transform: scale(0.322, 0.351) !important;
  }
  .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang5 {
    transform: scale(0.322, 0.354) !important;
  }
  .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang7 {
    transform: scale(0.322, 0.309) !important;
  }
  .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang8 {
    transform: scale(0.322, 0.399) !important;
  }



    @media (min-width: 768px) {
      .content-lefttdbodybluetheme {
        transform: scale(0.476, 0.49) !important;
      }
       .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang6 {
        transform: scale(0.476, 0.524) !important;
      }
      .content-lefttdbodynophotoheaderbulletscentersquaresidebar {
        transform: scale(0.476, 0.449) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheadercenter {
        transform: scale(0.476, 0.576) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheadercentersidebar {
        transform: scale(0.476, 0.549) !important;
      }

      .content-lefttdbodynophotoheaderbulletscentersquaresidebar2 {
        transform: scale(0.476, 0.395) !important;
      }
      .content-lefttdbodythemenophotocenterimages {
        transform: scale(0.476, 0.49) !important;
      }
      .content-lefttdbodywhitetheme {
        transform: scale(0.476, 0.492) !important;
      }
      .content-lefttdbodywhitethemedark2center {
        transform: scale(0.476, 0.493) !important;
      }
      .content-lefttdbodywhitethemenophoto {
        transform: scale(0.476, 0.357) !important;
      }
      .content-lefttdbodythemenophotoorange {
        transform: scale(0.476, 0.371) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang1 {
        transform: scale(0.476, 0.465) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheadercenteronecolumn {
        transform: scale(0.476, 0.556) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang2 {
        transform: scale(0.476, 0.527) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang3 {
        transform: scale(0.476, 0.574) !important;
      }
      .content-lefttdbodythemenophototopbox {
        transform: scale(0.476, 0.456) !important;
      }
      .content-lefttdbodygreentheme {
        transform: scale(0.476, 0.496) !important;
      }
      .content-lefttdbodywhitebluethemenophoto {
        transform: scale(0.476, 0.534) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheaderbulletscenter {
        transform: scale(0.476, 0.452) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheaderbullets {
        transform: scale(0.476, 0.398) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheaderbulletscentersquare {
        transform: scale(0.476, 0.453) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheaderbulletssquare {
        transform: scale(0.476, 0.505) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheaderbulletscentersquarebackgroundh3 {
        transform: scale(0.476, 0.503) !important;
      }
      .content-lefttdbodywhitethememulticolor {
        transform: scale(0.476, 0.50) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang4 {
        transform: scale(0.476, 0.519) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang5 {
        transform: scale(0.476, 0.524) !important;
      }

      .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang7 {
        transform: scale(0.476, 0.457) !important;
      }
      .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang8 {
        transform: scale(0.476, 0.591) !important;
      }
    }
  `;

  // Cover Letter constants

  textContent_cl_en_US = `
   .content-lefttdbodybluetheme {
      transform: scale(0.322, 0.3449) !important;
    }

    .content-lefttdbodywhitebluethemenophotoheadercentersidebar {
      transform: scale(0.322, 0.3584) !important;
    }

    .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang6 {
      transform: scale(0.322, 0.3504) !important;
    }

    .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang4 {
      transform: scale(0.322, 0.3569) !important;
    }

    .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang8 {
      transform: scale(0.322, 0.3478) !important;
    }


    @media (min-width: 768px) {
      .content-lefttdbodybluetheme {
        transform: scale(0.476, 0.51) !important;
      }

      .content-lefttdbodywhitebluethemenophotoheadercentersidebar {
        transform: scale(0.476, 0.53) !important;
      }

      .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang6 {
        transform: scale(0.476, 0.5182) !important;
      }

      .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang4 {
        transform: scale(0.476, 0.528) !important;
      }

      .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang8 {
        transform: scale(0.476, 0.515) !important;
      }
    }
`;

textContent_cl_en_GB = textContent_cl_en_US;

textContent_cl_de_DE = `
   .content-lefttdbodybluetheme {
      transform: scale(0.322, 0.345) !important; /* 0.51 * scaleFactor ≈ 0.345 */
    }

    .content-lefttdbodywhitebluethemenophotoheadercentersidebar {
      transform: scale(0.322, 0.359) !important; /* 0.53 * scaleFactor ≈ 0.359 */
    }

    .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang6 {
      transform: scale(0.322, 0.342) !important; /* 0.505 * scaleFactor ≈ 0.342 */
    }

    .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang4 {
      transform: scale(0.322, 0.357) !important; /* 0.528 * scaleFactor ≈ 0.357 */
    }

    .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang8 {
      transform: scale(0.322, 0.348) !important; /* 0.515 * scaleFactor ≈ 0.348 */
    }





    @media (min-width: 768px) {
      .content-lefttdbodybluetheme {
        transform: scale(0.476, 0.51) !important;
      }

      .content-lefttdbodywhitebluethemenophotoheadercentersidebar {
        transform: scale(0.476, 0.53) !important;
      }

      .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang6 {
        transform: scale(0.476, 0.505) !important;
      }

      .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang4 {
        transform: scale(0.476, 0.528) !important;
      }

      .content-lefttdbodywhitebluethemenophotoheadercenteronecolumnfang8 {
        transform: scale(0.476, 0.515) !important;
      }
    }
`;

  textContent_cl_fr_FR=textContent_cl_en_US;
  textContent_cl_es_419=textContent_cl_en_US;
  textContent_cl_ja_JP=textContent_cl_en_US;
  textContent_cl_it_IT=textContent_cl_en_US;
  textContent_cl_pt_BR=textContent_cl_en_US;
  textContent_cl_zh_CN=textContent_cl_en_US;

  };




  //  to filter pass filter horizontalslidersetup.init('fang', '/templates/default/6037a24ebdbd6/index.html', null);
  return {
    init: async (filterValue = null, sourceUrl, content, isResume = true) => {
      isUnloading = false; // Reset unloading flag when initializing
      await lazyLoadInit(filterValue, sourceUrl, content, isResume);
    },
    unload: () => {
      isUnloading = true;
      windowsStyles = '';
      textContent = '',
        textContent_en_US = '',
        textContent_de_DE = '',
        textContent_en_GB = '',
        textContent_fr_FR = '',
        textContent_es_419 = '',
        textContent_ja_JP = '',
        textContent_it_IT = '',
        textContent_pt_BR = '',
        textContent_zh_CN = '',
        textContent_cl_en_US = '',
        textContent_cl_de_DE = '',
        textContent_cl_en_GB = '',
        textContent_cl_fr_FR = '',
        textContent_cl_es_419 = '',
        textContent_cl_ja_JP = '',
        textContent_cl_it_IT = '',
        textContent_cl_pt_BR = '',
        textContent_cl_zh_CN = '',
        windowsEdgeStyles = '';

      // Remove all event listeners
      eventListeners.forEach(({ element, type, listener }) => {
        if (element) element.removeEventListener(type, listener);
      });
      eventListeners.length = 0; // Clear the event listeners array

      if (observer) {
        observer.disconnect(); // Stop observing all elements
        observer = null; // Clear the reference for garbage collection
      }

      if (shadowRoot) {
        // Remove all children from shadowRoot
        while (shadowRoot.firstChild) {
          shadowRoot.removeChild(shadowRoot.firstChild);
        }

        // Optionally remove event listeners from elements inside shadowRoot
        const shadowElements = shadowRoot.querySelectorAll("*");
        shadowElements.forEach(el => {
          el.replaceWith(el.cloneNode(true)); // Removes event listeners
        });

        shadowRoot = null; // Remove the reference for garbage collection
      }

      // Null check for container
      const container = document.getElementById("image-carousel-div");
      if (container) {
        removeAllChildrenAndStyles(container);
      }

      mainsliderContainer = null;
      mainsliderContainerMain = null;
      mainsliderWrapper = null;
      mainsliderFilterAttributes = null;
      mainsliderItems = null;
      mainsliderButtons = null;
      mainsliderCurrentSelectedSlide = null;
      imagecarouseldiv = null;
      observer = null;
    },
  };

})();


export default horizontalslidersetup;


